import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
};

export type Address = {
  __typename?: 'Address';
  additionalInformation: Maybe<Scalars['String']['output']>;
  addressLine1: Maybe<Scalars['String']['output']>;
  addressLine2: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  companyReg: Maybe<Scalars['String']['output']>;
  companyVat: Maybe<Scalars['String']['output']>;
  country: Maybe<Country>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  customer: Maybe<Customer>;
  defaultBillingAddress: Maybe<Scalars['Boolean']['output']>;
  defaultShippingAddress: Maybe<Scalars['Boolean']['output']>;
  defaultTransitAddress: Maybe<Scalars['Boolean']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  nickname: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['Int']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  vat: Maybe<Vat>;
  zip: Maybe<Scalars['String']['output']>;
};

export type AggregatedOrderTotal = {
  __typename?: 'AggregatedOrderTotal';
  additionalInfo: Maybe<Scalars['String']['output']>;
  sequence: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
  value: Maybe<Money>;
};

export type AvailableBrsb = {
  __typename?: 'AvailableBrsb';
  chainHash: Maybe<Scalars['String']['output']>;
  childRelationshipSupplierBrand: Maybe<BusinessRelationshipSupplierBrand>;
  relationSupplierHash: Maybe<Scalars['String']['output']>;
  relationshipSupplierBrand: Maybe<BusinessRelationshipSupplierBrand>;
};

export type B2cAboutYourselfInput = {
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  currencyId?: InputMaybe<Scalars['String']['input']>;
  isCompany?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type B2cBrand = {
  __typename?: 'B2cBrand';
  assets: Maybe<Array<Maybe<B2cBrandAsset>>>;
  defaultProductType: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  metaDescription: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  shortName: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  url: Maybe<Scalars['String']['output']>;
};

export type B2cBrandAsset = {
  __typename?: 'B2cBrandAsset';
  alt: Maybe<Scalars['String']['output']>;
  extension: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isMain: Maybe<Scalars['Boolean']['output']>;
  path: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type B2cCar = {
  __typename?: 'B2cCar';
  id: Scalars['String']['output'];
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  lvl: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  parent: Maybe<B2cCar>;
  slug: Scalars['String']['output'];
  type: Maybe<Scalars['String']['output']>;
};

export type B2cCartPayload = {
  __typename?: 'B2cCartPayload';
  cartProducts: Maybe<Array<Maybe<B2cCartProduct>>>;
  errors: Maybe<Array<Maybe<CartProductValidationMessage>>>;
  id: Scalars['String']['output'];
  number: Maybe<Scalars['Int']['output']>;
  totals: Maybe<Array<Maybe<CartTotal>>>;
};

export type B2cCartProduct = {
  __typename?: 'B2cCartProduct';
  factorOrderQuantity: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  maxOrderQuantity: Maybe<Scalars['Int']['output']>;
  minOrderQuantity: Maybe<Scalars['Int']['output']>;
  price: Maybe<Money>;
  priceId: Maybe<Scalars['String']['output']>;
  product: Maybe<B2cProductPayload>;
  quantity: Maybe<Scalars['Int']['output']>;
};

export type B2cCartProductInput = {
  cartId?: InputMaybe<Scalars['String']['input']>;
  cartProductId?: InputMaybe<Scalars['String']['input']>;
  priceId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type B2cCategory = {
  __typename?: 'B2cCategory';
  icon: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image: Maybe<Scalars['String']['output']>;
  level: Maybe<Scalars['Int']['output']>;
  lft: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  parent: Maybe<B2cCategory>;
  rgt: Maybe<Scalars['Int']['output']>;
  shortName: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type B2cCategoryTreePayload = {
  __typename?: 'B2cCategoryTreePayload';
  children: Maybe<Array<Maybe<B2cCategoryTreePayload>>>;
  description: Maybe<Scalars['String']['output']>;
  icon: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image: Maybe<Scalars['String']['output']>;
  metaDescription: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  shortName: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Maybe<Scalars['String']['output']>;
};

export type B2cCustomer = {
  __typename?: 'B2cCustomer';
  country: Maybe<Country>;
  currency: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  locale: Maybe<Scalars['String']['output']>;
};

export type B2cCustomerChannelPayload = {
  __typename?: 'B2cCustomerChannelPayload';
  availableCountries: Maybe<Array<Maybe<Country>>>;
  currentCountry: Maybe<Country>;
  customer: Maybe<B2cCustomer>;
  salesChannel: Maybe<SalesChannelOptions>;
  vatCoefficient: Maybe<Scalars['Int']['output']>;
};

export type B2cMutation = {
  __typename?: 'B2cMutation';
  CartUpdateProduct: B2cCartPayload;
  RecoveryPassword: Maybe<Scalars['Boolean']['output']>;
  Registration: B2cRegistrationPayload;
  SendRecoveryPasswordMail: Maybe<Scalars['Boolean']['output']>;
  UpdateAboutYourself: Scalars['Boolean']['output'];
};


export type B2cMutationCartUpdateProductArgs = {
  input: B2cCartProductInput;
};


export type B2cMutationRecoveryPasswordArgs = {
  input: ResetPasswordInput;
};


export type B2cMutationRegistrationArgs = {
  input: RegistrationInput;
};


export type B2cMutationSendRecoveryPasswordMailArgs = {
  input: SendRecoveryPasswordMailInput;
};


export type B2cMutationUpdateAboutYourselfArgs = {
  input: B2cAboutYourselfInput;
};

export type B2cProductAsset = {
  __typename?: 'B2cProductAsset';
  alt: Maybe<Scalars['String']['output']>;
  extension: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isMain: Maybe<Scalars['Boolean']['output']>;
  path: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type B2cProductInfo = {
  __typename?: 'B2cProductInfo';
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  metaDescription: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
};

export type B2cProductParameter = {
  __typename?: 'B2cProductParameter';
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type B2cProductPayload = {
  __typename?: 'B2cProductPayload';
  brand: Maybe<B2cBrand>;
  cars: Maybe<Array<Maybe<B2cCar>>>;
  categories: Maybe<Array<Maybe<B2cCategory>>>;
  crosses: Maybe<Array<Maybe<B2cProductPayload>>>;
  dimensions: Maybe<Dimensions>;
  ean: Maybe<Scalars['String']['output']>;
  exchanges: Maybe<Array<Maybe<B2cProductPayload>>>;
  hsCode: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  keepFlat: Maybe<Scalars['Boolean']['output']>;
  minimalOrderQuantity: Maybe<Scalars['Int']['output']>;
  mpn: Maybe<Scalars['String']['output']>;
  mpnAnalyzed: Maybe<Scalars['String']['output']>;
  mpnFormatted: Maybe<Scalars['String']['output']>;
  prices: Maybe<Array<Maybe<B2cProductPrice>>>;
  productAssets: Maybe<Array<Maybe<B2cProductAsset>>>;
  productInfo: Maybe<B2cProductInfo>;
  productParameters: Maybe<Array<Maybe<B2cProductParameter>>>;
  productType: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['Int']['output']>;
  weight: Maybe<Weight>;
};

export type B2cProductPrice = {
  __typename?: 'B2cProductPrice';
  availableStockCount: Maybe<Scalars['Int']['output']>;
  brand: Maybe<B2cBrand>;
  deliveryTermExpressMax: Maybe<Scalars['Int']['output']>;
  deliveryTermExpressMin: Maybe<Scalars['Int']['output']>;
  deliveryTermStandardMax: Maybe<Scalars['Int']['output']>;
  deliveryTermStandardMin: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isLocalStockSupplier: Maybe<Scalars['Boolean']['output']>;
  price: Maybe<Money>;
  supplierName: Maybe<Scalars['String']['output']>;
};

export type B2cProductSearchPayload = {
  __typename?: 'B2cProductSearchPayload';
  brandName: Maybe<Scalars['String']['output']>;
  categories: Maybe<Array<Maybe<B2cCategory>>>;
  dimensions: Maybe<Dimensions>;
  ean: Maybe<Scalars['String']['output']>;
  hsCode: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  keepFlat: Maybe<Scalars['Boolean']['output']>;
  maxPrice: Maybe<Scalars['Int']['output']>;
  minPrice: Maybe<Scalars['Int']['output']>;
  minimalOrderQuantity: Maybe<Scalars['Int']['output']>;
  mpn: Maybe<Scalars['String']['output']>;
  mpnAnalyzed: Maybe<Scalars['String']['output']>;
  mpnFormatted: Maybe<Scalars['String']['output']>;
  productAssets: Maybe<Array<Maybe<B2cProductAsset>>>;
  productInfo: Maybe<B2cProductInfo>;
  state: Maybe<Scalars['Int']['output']>;
  url: Maybe<Scalars['String']['output']>;
  weight: Maybe<Weight>;
};

export type B2cProductsSearchInput = {
  filter?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type B2cProductsSearchPayload = {
  __typename?: 'B2cProductsSearchPayload';
  categories: Maybe<Array<Maybe<B2cCategoryTreePayload>>>;
  pagination: Maybe<Pagination>;
  records: Maybe<Array<Maybe<B2cProductSearchPayload>>>;
};

export type B2cQuery = {
  __typename?: 'B2cQuery';
  Brand: Maybe<B2cBrand>;
  BrandsByCategory: Maybe<Array<Maybe<B2cBrand>>>;
  BrandsList: Array<B2cBrand>;
  CarBrandsList: Array<B2cBrand>;
  Cart: Maybe<B2cCartPayload>;
  CartForCheckout: Maybe<CartPayload>;
  CategoriesByBrand: Maybe<Array<Maybe<B2cCategory>>>;
  CategoriesBySlugs: Maybe<Array<Maybe<B2cCategory>>>;
  CategoriesTree: Maybe<Array<Maybe<B2cCategoryTreePayload>>>;
  CustomerChannel: Maybe<B2cCustomerChannelPayload>;
  FeaturedBrandsList: Array<FeaturedBrand>;
  MinimalShippingRate: Maybe<MinimalShippingPayload>;
  Product: Maybe<B2cProductPayload>;
  ProductsSearch: Maybe<B2cProductsSearchPayload>;
  RootCategoriesPreview: Maybe<Array<Maybe<Category>>>;
  StaticPageContent: Maybe<StaticPageContentType>;
  TopCategories: Maybe<Array<Maybe<TopCategory>>>;
  UrlData: Maybe<B2cUrlDataPayload>;
};


export type B2cQueryBrandArgs = {
  input: BrandQueryInput;
};


export type B2cQueryBrandsByCategoryArgs = {
  input: BrandsByCategoryInput;
};


export type B2cQueryCartForCheckoutArgs = {
  input: InputMaybe<CartSessionInput>;
};


export type B2cQueryCategoriesByBrandArgs = {
  input: CategoriesByBrandInput;
};


export type B2cQueryCategoriesBySlugsArgs = {
  input: CategoriesBySlugsInput;
};


export type B2cQueryMinimalShippingRateArgs = {
  input: ShippingRateInput;
};


export type B2cQueryProductArgs = {
  input: ProductQueryInput;
};


export type B2cQueryProductsSearchArgs = {
  input: B2cProductsSearchInput;
};


export type B2cQueryStaticPageContentArgs = {
  input: StaticPageContentInput;
};


export type B2cQueryUrlDataArgs = {
  input: UrlDataQueryInput;
};

export type B2cRegistrationPayload = {
  __typename?: 'B2cRegistrationPayload';
  billingEmail: Maybe<Scalars['String']['output']>;
  companyVat: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  locale: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
};

export type B2cUrlDataPayload = {
  __typename?: 'B2cUrlDataPayload';
  brand: Maybe<B2cBrand>;
  category: Maybe<B2cCategory>;
  product: Maybe<B2cProductPayload>;
  type: Maybe<Scalars['String']['output']>;
};

export type BoxTemplate = {
  __typename?: 'BoxTemplate';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  depth: Maybe<Scalars['Int']['output']>;
  height: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['String']['output']>;
  key: Maybe<Scalars['String']['output']>;
  sortWeight: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  width: Maybe<Scalars['Int']['output']>;
};

export type BrandQueryInput = {
  brandId?: InputMaybe<Scalars['String']['input']>;
};

export type BrandWeight = {
  __typename?: 'BrandWeight';
  brand: Maybe<Scalars['String']['output']>;
  weight: Maybe<Weight>;
};

export type BrandsByCategoryInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
};

export type Business = {
  code: Maybe<Scalars['String']['output']>;
  country: Maybe<Country>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  defaultCurrency: Maybe<Currency>;
  email: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  legalAddress: Maybe<Scalars['String']['output']>;
  legalAddressCity: Maybe<Scalars['String']['output']>;
  legalAddressRegion: Maybe<Scalars['String']['output']>;
  legalAddressZip: Maybe<Scalars['String']['output']>;
  location: Maybe<Array<Maybe<WarehouseLocation>>>;
  name: Maybe<Scalars['String']['output']>;
  parameters: Maybe<Array<Maybe<BusinessParameter>>>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type BusinessBrand = {
  __typename?: 'BusinessBrand';
  assets: Maybe<Array<Maybe<BusinessBrandAsset>>>;
  business: Maybe<Business>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  defaultProductType: Maybe<Scalars['String']['output']>;
  deliveryTermExpress: Maybe<Scalars['Int']['output']>;
  deliveryTermStandard: Maybe<Scalars['Int']['output']>;
  esteriolHash: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  shortName: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  specificationAvailable: Maybe<Scalars['Boolean']['output']>;
  translation: Maybe<BusinessBrandTranslation>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type BusinessBrandAsset = {
  __typename?: 'BusinessBrandAsset';
  businessBrand: Maybe<BusinessBrand>;
  id: Maybe<Scalars['String']['output']>;
  path: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type BusinessBrandTranslation = {
  __typename?: 'BusinessBrandTranslation';
  descriptionDe: Maybe<Scalars['String']['output']>;
  descriptionEn: Maybe<Scalars['String']['output']>;
  descriptionEs: Maybe<Scalars['String']['output']>;
  descriptionFr: Maybe<Scalars['String']['output']>;
  descriptionPl: Maybe<Scalars['String']['output']>;
  descriptionRu: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  metaDescriptionDe: Maybe<Scalars['String']['output']>;
  metaDescriptionEn: Maybe<Scalars['String']['output']>;
  metaDescriptionEs: Maybe<Scalars['String']['output']>;
  metaDescriptionFr: Maybe<Scalars['String']['output']>;
  metaDescriptionPl: Maybe<Scalars['String']['output']>;
  metaDescriptionRu: Maybe<Scalars['String']['output']>;
  nameDe: Maybe<Scalars['String']['output']>;
  nameEn: Maybe<Scalars['String']['output']>;
  nameEs: Maybe<Scalars['String']['output']>;
  nameFr: Maybe<Scalars['String']['output']>;
  namePl: Maybe<Scalars['String']['output']>;
  nameRu: Maybe<Scalars['String']['output']>;
  shortNameDe: Maybe<Scalars['String']['output']>;
  shortNameEn: Maybe<Scalars['String']['output']>;
  shortNameEs: Maybe<Scalars['String']['output']>;
  shortNameFr: Maybe<Scalars['String']['output']>;
  shortNamePl: Maybe<Scalars['String']['output']>;
  shortNameRu: Maybe<Scalars['String']['output']>;
  slugDe: Maybe<Scalars['String']['output']>;
  slugEn: Maybe<Scalars['String']['output']>;
  slugEs: Maybe<Scalars['String']['output']>;
  slugFr: Maybe<Scalars['String']['output']>;
  slugPl: Maybe<Scalars['String']['output']>;
  slugRu: Maybe<Scalars['String']['output']>;
};

export type BusinessDistributor = Business & {
  __typename?: 'BusinessDistributor';
  actualAddress: Maybe<Scalars['String']['output']>;
  adyenApiKey: Maybe<Scalars['String']['output']>;
  adyenGenericHmacSignature: Maybe<Scalars['String']['output']>;
  adyenHmacSignature: Maybe<Scalars['String']['output']>;
  adyenLiveEndpointPrefix: Maybe<Scalars['String']['output']>;
  adyenMerchant: Maybe<Scalars['String']['output']>;
  adyenTransferPendingHmacSignature: Maybe<Scalars['String']['output']>;
  banks: Maybe<Array<Maybe<BusinessDistributorBank>>>;
  code: Maybe<Scalars['String']['output']>;
  country: Maybe<Country>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  defaultCurrency: Maybe<Currency>;
  domain: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoiceLanguage: Maybe<Scalars['String']['output']>;
  invoiceNumberPrefix: Maybe<Scalars['String']['output']>;
  isAdyenEnabled: Maybe<Scalars['Boolean']['output']>;
  isDuplicateMailSentToSupplier: Maybe<Scalars['Boolean']['output']>;
  isInvoiceExporterNoteEnabled: Maybe<Scalars['Boolean']['output']>;
  isPaypalEnabled: Maybe<Scalars['Boolean']['output']>;
  issuer: Maybe<Scalars['String']['output']>;
  legalAddress: Maybe<Scalars['String']['output']>;
  legalAddressCity: Maybe<Scalars['String']['output']>;
  legalAddressRegion: Maybe<Scalars['String']['output']>;
  legalAddressZip: Maybe<Scalars['String']['output']>;
  location: Maybe<Array<Maybe<WarehouseLocation>>>;
  logo: Maybe<Scalars['String']['output']>;
  main: Maybe<Scalars['Boolean']['output']>;
  markupFormulaExtraCosts: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  parameters: Maybe<Array<Maybe<BusinessParameter>>>;
  paypalClientId: Maybe<Scalars['String']['output']>;
  paypalSecret: Maybe<Scalars['String']['output']>;
  paypalWebhookId: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  regNr: Maybe<Scalars['String']['output']>;
  saasClient: Maybe<SaasClient>;
  skipProfitInManagerGoals: Maybe<Scalars['Boolean']['output']>;
  status: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  vatCoefficient: Maybe<Scalars['Int']['output']>;
  vatNr: Maybe<Scalars['String']['output']>;
};

export type BusinessDistributorBank = {
  __typename?: 'BusinessDistributorBank';
  accounts: Maybe<Array<Maybe<BusinessDistributorBankAccount>>>;
  address: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  default: Maybe<Scalars['Boolean']['output']>;
  iban: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoicePosition: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['Int']['output']>;
  swift: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type BusinessDistributorBankAccount = {
  __typename?: 'BusinessDistributorBankAccount';
  account: Maybe<Scalars['String']['output']>;
  businessDistributorBank: Maybe<BusinessDistributorBank>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  currency: Maybe<Currency>;
  id: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type BusinessParameter = {
  __typename?: 'BusinessParameter';
  business: Maybe<Business>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  key: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type BusinessRelationship = {
  __typename?: 'BusinessRelationship';
  child: Maybe<Business>;
  createBrsbOnBrandAdd: Maybe<Scalars['Boolean']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deliveryTermExpressAvg: Maybe<Scalars['Int']['output']>;
  deliveryTermExpressMax: Maybe<Scalars['Int']['output']>;
  deliveryTermExpressMin: Maybe<Scalars['Int']['output']>;
  deliveryTermStandardAvg: Maybe<Scalars['Int']['output']>;
  deliveryTermStandardMax: Maybe<Scalars['Int']['output']>;
  deliveryTermStandardMin: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['String']['output']>;
  markup: Maybe<Scalars['Int']['output']>;
  parent: Maybe<Business>;
  synchronize: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type BusinessRelationshipSupplierBrand = {
  __typename?: 'BusinessRelationshipSupplierBrand';
  businessRelationship: Maybe<BusinessRelationship>;
  businessSupplierBrand: Maybe<BusinessSupplierBrand>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  directDistributor: Maybe<Business>;
  id: Maybe<Scalars['String']['output']>;
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isParentEnabled: Maybe<Scalars['Boolean']['output']>;
  markup: Maybe<Scalars['Int']['output']>;
  modifiedBy: Maybe<Employee>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type BusinessSupplier = Business & {
  __typename?: 'BusinessSupplier';
  brands: Maybe<Array<Maybe<BusinessSupplierBrand>>>;
  code: Maybe<Scalars['String']['output']>;
  country: Maybe<Country>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  defaultCurrency: Maybe<Currency>;
  email: Maybe<Scalars['String']['output']>;
  enabledSupplierLocations: Maybe<Array<Maybe<SupplierLocation>>>;
  id: Maybe<Scalars['String']['output']>;
  invoiceComment: Maybe<Scalars['String']['output']>;
  legalAddress: Maybe<Scalars['String']['output']>;
  legalAddressCity: Maybe<Scalars['String']['output']>;
  legalAddressRegion: Maybe<Scalars['String']['output']>;
  legalAddressZip: Maybe<Scalars['String']['output']>;
  location: Maybe<Array<Maybe<WarehouseLocation>>>;
  name: Maybe<Scalars['String']['output']>;
  onlyStockProducts: Maybe<Scalars['Boolean']['output']>;
  parameters: Maybe<Array<Maybe<BusinessParameter>>>;
  publicName: Maybe<Scalars['String']['output']>;
  realName: Maybe<Scalars['String']['output']>;
  sellAllowed: Maybe<Scalars['Boolean']['output']>;
  showProductsPurchasePrices: Maybe<Scalars['Boolean']['output']>;
  supplierLocations: Maybe<Array<Maybe<SupplierLocation>>>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  waybillProcessor: Maybe<Scalars['String']['output']>;
};

export type BusinessSupplierBrand = {
  __typename?: 'BusinessSupplierBrand';
  brand: Maybe<BusinessBrand>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deliveryTermExpressAvg: Maybe<Scalars['Int']['output']>;
  deliveryTermExpressMax: Maybe<Scalars['Int']['output']>;
  deliveryTermExpressMin: Maybe<Scalars['Int']['output']>;
  deliveryTermStandardAvg: Maybe<Scalars['Int']['output']>;
  deliveryTermStandardMax: Maybe<Scalars['Int']['output']>;
  deliveryTermStandardMin: Maybe<Scalars['Int']['output']>;
  distributor: Maybe<BusinessDistributor>;
  email: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  supplier: Maybe<BusinessSupplier>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type Cart = {
  __typename?: 'Cart';
  availableCoupons: Maybe<Array<Maybe<Coupon>>>;
  billingAddressId: Maybe<Scalars['String']['output']>;
  billingAddressLine1: Maybe<Scalars['String']['output']>;
  billingAddressLine2: Maybe<Scalars['String']['output']>;
  billingCity: Maybe<Scalars['String']['output']>;
  billingCompanyName: Maybe<Scalars['String']['output']>;
  billingCompanyReg: Maybe<Scalars['String']['output']>;
  billingCompanyVat: Maybe<Scalars['String']['output']>;
  billingCountry: Maybe<Country>;
  billingFirstName: Maybe<Scalars['String']['output']>;
  billingLastName: Maybe<Scalars['String']['output']>;
  billingNickname: Maybe<Scalars['String']['output']>;
  billingPhone: Maybe<Scalars['String']['output']>;
  billingRegion: Maybe<Scalars['String']['output']>;
  billingSameAsShipping: Maybe<Scalars['Boolean']['output']>;
  billingVatData: Maybe<Vat>;
  billingZip: Maybe<Scalars['String']['output']>;
  cartProducts: Maybe<Array<Maybe<CartProduct>>>;
  comment: Maybe<Scalars['String']['output']>;
  coupons: Maybe<Array<Maybe<Coupon>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  currencyCode: Maybe<Scalars['String']['output']>;
  currencyRate: Maybe<Scalars['Int']['output']>;
  customer: Maybe<Customer>;
  email: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoiceReference: Maybe<Scalars['String']['output']>;
  isShippingInsuranceApplied: Maybe<Scalars['Boolean']['output']>;
  isTransitIncluded: Maybe<Scalars['Boolean']['output']>;
  number: Maybe<Scalars['Int']['output']>;
  paymentType: Maybe<Scalars['String']['output']>;
  shippingAddressId: Maybe<Scalars['String']['output']>;
  shippingAddressLine1: Maybe<Scalars['String']['output']>;
  shippingAddressLine2: Maybe<Scalars['String']['output']>;
  shippingCity: Maybe<Scalars['String']['output']>;
  shippingCompanyName: Maybe<Scalars['String']['output']>;
  shippingCompanyReg: Maybe<Scalars['String']['output']>;
  shippingCompanyVat: Maybe<Scalars['String']['output']>;
  shippingCountry: Maybe<Country>;
  shippingFirstName: Maybe<Scalars['String']['output']>;
  shippingLastName: Maybe<Scalars['String']['output']>;
  shippingMethod: Maybe<Scalars['String']['output']>;
  shippingNickname: Maybe<Scalars['String']['output']>;
  shippingPhone: Maybe<Scalars['String']['output']>;
  shippingRegion: Maybe<Scalars['String']['output']>;
  shippingSelfPickup: Maybe<Scalars['Boolean']['output']>;
  shippingSupplier: Maybe<Scalars['String']['output']>;
  shippingVatData: Maybe<Vat>;
  shippingZip: Maybe<Scalars['String']['output']>;
  totals: Maybe<Array<Maybe<CartTotal>>>;
  transitAddressId: Maybe<Scalars['String']['output']>;
  transitAddressLine1: Maybe<Scalars['String']['output']>;
  transitAddressLine2: Maybe<Scalars['String']['output']>;
  transitCity: Maybe<Scalars['String']['output']>;
  transitCompanyName: Maybe<Scalars['String']['output']>;
  transitCompanyReg: Maybe<Scalars['String']['output']>;
  transitCompanyVat: Maybe<Scalars['String']['output']>;
  transitCountry: Maybe<Country>;
  transitFirstName: Maybe<Scalars['String']['output']>;
  transitLastName: Maybe<Scalars['String']['output']>;
  transitNickname: Maybe<Scalars['String']['output']>;
  transitPhone: Maybe<Scalars['String']['output']>;
  transitRegion: Maybe<Scalars['String']['output']>;
  transitZip: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  vinCode: Maybe<Scalars['String']['output']>;
};

export type CartPayload = {
  __typename?: 'CartPayload';
  adyenClientKey: Maybe<Scalars['String']['output']>;
  adyenEnvironment: Maybe<Scalars['String']['output']>;
  adyenPaymentMethods: Maybe<PaymentMethodsList>;
  cart: Maybe<Cart>;
  currency: Maybe<Scalars['String']['output']>;
  defaultCountry: Maybe<Scalars['String']['output']>;
  needToAgreeSanctionTerms: Maybe<Scalars['Boolean']['output']>;
  paypalClientId: Maybe<Scalars['String']['output']>;
  paypalCommit: Maybe<Scalars['String']['output']>;
  paypalIntent: Maybe<Scalars['String']['output']>;
  shippingSelfPickup: Maybe<Scalars['Boolean']['output']>;
};

export type CartProduct = {
  __typename?: 'CartProduct';
  addedFromBrand: Maybe<Product>;
  addedFromMpn: Maybe<Scalars['String']['output']>;
  addedFromProduct: Maybe<Product>;
  addedFromType: Maybe<Scalars['String']['output']>;
  availableQuantity: Maybe<Scalars['Int']['output']>;
  businessRelationshipSupplierChainHash: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  depositAmount: Maybe<Money>;
  discount: Maybe<Scalars['Int']['output']>;
  esteriolId: Maybe<Scalars['Int']['output']>;
  exchangeProduct: Maybe<Product>;
  id: Maybe<Scalars['String']['output']>;
  initialPrice: Maybe<Money>;
  price: Maybe<Money>;
  product: Maybe<Product>;
  productDiscount: Maybe<Discount>;
  quantity: Maybe<Scalars['Int']['output']>;
  relationshipSupplierBrand: Maybe<BusinessRelationshipSupplierBrand>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type CartProductValidationMessage = {
  __typename?: 'CartProductValidationMessage';
  message: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type CartSessionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type CartTotal = {
  __typename?: 'CartTotal';
  additionalInfo: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  sequence: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  value: Maybe<Money>;
};

export type CategoriesByBrandInput = {
  brandId?: InputMaybe<Scalars['String']['input']>;
};

export type CategoriesBySlugsInput = {
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Category = {
  __typename?: 'Category';
  assets: Maybe<Array<Maybe<CategoryAsset>>>;
  children: Maybe<Array<Maybe<Category>>>;
  id: Maybe<Scalars['String']['output']>;
  lft: Maybe<Scalars['Int']['output']>;
  lvl: Maybe<Scalars['Int']['output']>;
  parent: Maybe<Category>;
  rgt: Maybe<Scalars['Int']['output']>;
  root: Maybe<Category>;
  translation: Maybe<CategoryTranslation>;
  type: Maybe<Scalars['String']['output']>;
};

export type CategoryAsset = {
  __typename?: 'CategoryAsset';
  category: Maybe<Category>;
  id: Maybe<Scalars['String']['output']>;
  path: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type CategoryTranslation = {
  __typename?: 'CategoryTranslation';
  category: Maybe<Category>;
  descriptionDe: Maybe<Scalars['String']['output']>;
  descriptionEn: Maybe<Scalars['String']['output']>;
  descriptionEs: Maybe<Scalars['String']['output']>;
  descriptionFr: Maybe<Scalars['String']['output']>;
  descriptionKo: Maybe<Scalars['String']['output']>;
  descriptionPl: Maybe<Scalars['String']['output']>;
  descriptionRu: Maybe<Scalars['String']['output']>;
  descriptionZh: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  metaDescriptionDe: Maybe<Scalars['String']['output']>;
  metaDescriptionEn: Maybe<Scalars['String']['output']>;
  metaDescriptionEs: Maybe<Scalars['String']['output']>;
  metaDescriptionFr: Maybe<Scalars['String']['output']>;
  metaDescriptionKo: Maybe<Scalars['String']['output']>;
  metaDescriptionPl: Maybe<Scalars['String']['output']>;
  metaDescriptionRu: Maybe<Scalars['String']['output']>;
  metaDescriptionZh: Maybe<Scalars['String']['output']>;
  nameDe: Maybe<Scalars['String']['output']>;
  nameEn: Maybe<Scalars['String']['output']>;
  nameEs: Maybe<Scalars['String']['output']>;
  nameFr: Maybe<Scalars['String']['output']>;
  nameKo: Maybe<Scalars['String']['output']>;
  namePl: Maybe<Scalars['String']['output']>;
  nameRu: Maybe<Scalars['String']['output']>;
  nameZh: Maybe<Scalars['String']['output']>;
  shortNameDe: Maybe<Scalars['String']['output']>;
  shortNameEn: Maybe<Scalars['String']['output']>;
  shortNameEs: Maybe<Scalars['String']['output']>;
  shortNameFr: Maybe<Scalars['String']['output']>;
  shortNameKo: Maybe<Scalars['String']['output']>;
  shortNamePl: Maybe<Scalars['String']['output']>;
  shortNameRu: Maybe<Scalars['String']['output']>;
  shortNameZh: Maybe<Scalars['String']['output']>;
  slugDe: Maybe<Scalars['String']['output']>;
  slugEn: Maybe<Scalars['String']['output']>;
  slugEs: Maybe<Scalars['String']['output']>;
  slugFr: Maybe<Scalars['String']['output']>;
  slugKo: Maybe<Scalars['String']['output']>;
  slugPl: Maybe<Scalars['String']['output']>;
  slugRu: Maybe<Scalars['String']['output']>;
  slugZh: Maybe<Scalars['String']['output']>;
};

export type CategoryType = {
  __typename?: 'CategoryType';
  id: Maybe<Scalars['String']['output']>;
  productCategoryTypes: Maybe<Array<Maybe<ProductCategoryType>>>;
  type: Maybe<Scalars['String']['output']>;
};

export type Country = {
  __typename?: 'Country';
  code: Maybe<Scalars['String']['output']>;
  currencyCode: Maybe<Scalars['String']['output']>;
  esteriolHash: Maybe<Scalars['String']['output']>;
  europeanUnion: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  nameRu: Maybe<Scalars['String']['output']>;
  vatRate: Maybe<Scalars['Int']['output']>;
};

export type Coupon = {
  __typename?: 'Coupon';
  businesses: Maybe<Array<Maybe<BusinessDistributor>>>;
  cartFilter: Maybe<Scalars['String']['output']>;
  cartProductFilter: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  dateTimeFrom: Maybe<Scalars['DateTime']['output']>;
  dateTimeTo: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  discountType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  mathOperator: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Employee>;
  name: Maybe<Scalars['String']['output']>;
  profit: Maybe<Scalars['Int']['output']>;
  revenue: Maybe<Scalars['Float']['output']>;
  status: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  usedCount: Maybe<Scalars['Int']['output']>;
  value: Maybe<Scalars['Int']['output']>;
};

export type CreditNoteCoupon = {
  __typename?: 'CreditNoteCoupon';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoiceCreditNote: Maybe<InvoiceCreditNote>;
  orderCoupon: Maybe<OrderCoupon>;
  total: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type Currency = {
  __typename?: 'Currency';
  base: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  date: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  rate: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type Customer = {
  abbr: Maybe<Scalars['String']['output']>;
  accountingMarker: Maybe<Scalars['String']['output']>;
  activatedAt: Maybe<Scalars['DateTime']['output']>;
  addresses: Maybe<Array<Maybe<Address>>>;
  approachingExpiryInvoicesNotifications: Maybe<Scalars['Boolean']['output']>;
  balance: Maybe<Money>;
  bankTransfer: Maybe<Scalars['Boolean']['output']>;
  banned: Maybe<Scalars['Boolean']['output']>;
  billingEmail: Maybe<Scalars['String']['output']>;
  boxes: Maybe<Array<Maybe<CustomerBox>>>;
  brandMarkups: Maybe<Array<Maybe<CustomerBrandMarkup>>>;
  business: Maybe<Business>;
  canNotOrderLessThanMin: Maybe<Scalars['Boolean']['output']>;
  cart: Maybe<Cart>;
  cartProductsCount: Maybe<Scalars['Int']['output']>;
  comments: Maybe<Array<Maybe<CustomerComment>>>;
  companyName: Maybe<Scalars['String']['output']>;
  companyReg: Maybe<Scalars['String']['output']>;
  companyVat: Maybe<Scalars['String']['output']>;
  country: Maybe<Country>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdFromOrder: Maybe<Order>;
  creditLimit: Maybe<Money>;
  currency: Maybe<Scalars['String']['output']>;
  dateFormat: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  expiredInvoicesNotifications: Maybe<Scalars['Boolean']['output']>;
  guest: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['String']['output']>;
  individualDelivery: Maybe<Scalars['Boolean']['output']>;
  isBlocked: Maybe<Scalars['Boolean']['output']>;
  isBusinessCabinetAllowed: Maybe<Scalars['Boolean']['output']>;
  isCompany: Maybe<Scalars['Boolean']['output']>;
  isFullOrderPacking: Maybe<Scalars['Boolean']['output']>;
  isInvoiceHSCodeVisible: Maybe<Scalars['Boolean']['output']>;
  isNotPackingBrandedTape: Maybe<Scalars['Boolean']['output']>;
  isNotPackingPallet: Maybe<Scalars['Boolean']['output']>;
  isReconciliationDownloadable: Maybe<Scalars['Boolean']['output']>;
  lastLogin: Maybe<Scalars['DateTime']['output']>;
  lastOrder: Maybe<Order>;
  lastUsedVersion: Maybe<Scalars['String']['output']>;
  lastVisit: Maybe<Scalars['DateTime']['output']>;
  locale: Maybe<Scalars['String']['output']>;
  manager: Maybe<Employee>;
  markupFormulaExtraCosts: Maybe<Scalars['String']['output']>;
  notifications: Maybe<Array<Maybe<CustomerNotification>>>;
  number: Maybe<Scalars['Int']['output']>;
  orderLock: Maybe<Scalars['Boolean']['output']>;
  orders: Maybe<Array<Maybe<Order>>>;
  ordersCount: Maybe<Scalars['Int']['output']>;
  ordersTotal: Maybe<Money>;
  packingBoxTemplate: Maybe<BoxTemplate>;
  packingCustomConditions: Maybe<Scalars['String']['output']>;
  paymentTerm: Maybe<Scalars['Int']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  potential: Maybe<Scalars['Boolean']['output']>;
  remainingBalance: Maybe<Money>;
  requests: Maybe<Array<Maybe<CustomerRequest>>>;
  selfPickup: Maybe<Scalars['Boolean']['output']>;
  shippingIndividual: Maybe<Scalars['Boolean']['output']>;
  source: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  useAsRootPrice: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerBox = {
  __typename?: 'CustomerBox';
  childBoxes: Maybe<Array<Maybe<CustomerBox>>>;
  code: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  customer: Maybe<Customer>;
  dimensions: Maybe<Dimensions>;
  id: Maybe<Scalars['String']['output']>;
  latestPackingList: Maybe<Document>;
  location: Maybe<WarehouseLocation>;
  modifiedBy: Maybe<Employee>;
  packingLists: Maybe<Array<Maybe<Document>>>;
  parent: Maybe<CustomerBox>;
  products: Maybe<Array<Maybe<CustomerBoxProduct>>>;
  productsCount: Maybe<Scalars['Int']['output']>;
  qrLabelComment: Maybe<Scalars['String']['output']>;
  sequence: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['String']['output']>;
  totalWeight: Maybe<Weight>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  weight: Maybe<Weight>;
};

export type CustomerBoxProduct = {
  __typename?: 'CustomerBoxProduct';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  customerBox: Maybe<CustomerBox>;
  id: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Employee>;
  orderProduct: Maybe<OrderProduct>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerBrandMarkup = {
  __typename?: 'CustomerBrandMarkup';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  customer: Maybe<Customer>;
  id: Maybe<Scalars['String']['output']>;
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  markup: Maybe<Scalars['Int']['output']>;
  modifiedBy: Maybe<Employee>;
  publicMarkup: Maybe<Scalars['Int']['output']>;
  relationshipSupplierBrand: Maybe<BusinessRelationshipSupplierBrand>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerComment = {
  __typename?: 'CustomerComment';
  content: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  customer: Maybe<Customer>;
  employee: Maybe<Employee>;
  id: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerNotification = {
  __typename?: 'CustomerNotification';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  customer: Maybe<Customer>;
  id: Maybe<Scalars['String']['output']>;
  key: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  value: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerRequest = {
  __typename?: 'CustomerRequest';
  accessCode: Maybe<Scalars['String']['output']>;
  closedDate: Maybe<Scalars['DateTime']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  completion: Maybe<Scalars['Int']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  customer: Maybe<Customer>;
  hash: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['Int']['output']>;
  orderDate: Maybe<Scalars['DateTime']['output']>;
  parent: Maybe<CustomerRequest>;
  requestProducts: Maybe<Array<Maybe<CustomerRequestProduct>>>;
  sentAt: Maybe<Scalars['DateTime']['output']>;
  sentLog: Maybe<Array<Maybe<CustomerRequestSent>>>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerRequestProduct = {
  __typename?: 'CustomerRequestProduct';
  businessRelationshipSupplierBrand: Maybe<BusinessRelationshipSupplierBrand>;
  chainHash: Maybe<Scalars['String']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  count: Maybe<Scalars['Int']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  customerWorkspaceProduct: Maybe<CustomerWorkspaceProduct>;
  deliveryDate: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  linkedRequestProduct: Maybe<CustomerRequestProduct>;
  number: Maybe<Scalars['Int']['output']>;
  price: Maybe<Money>;
  product: Maybe<Product>;
  request: Maybe<CustomerRequest>;
  stockCount: Maybe<Scalars['Int']['output']>;
  stockExchangeMpn: Maybe<Scalars['String']['output']>;
  stockStatus: Maybe<Scalars['String']['output']>;
  totalPrice: Maybe<Money>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerRequestSent = {
  __typename?: 'CustomerRequestSent';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  request: Maybe<CustomerRequest>;
  sentAt: Maybe<Scalars['DateTime']['output']>;
  sentTo: Maybe<Scalars['String']['output']>;
  sentToBusinessName: Maybe<Scalars['String']['output']>;
  toBusiness: Maybe<Business>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerWorkspaceProduct = {
  __typename?: 'CustomerWorkspaceProduct';
  analogues: Maybe<Array<Maybe<Product>>>;
  businessRelationshipSupplierBrand: Maybe<BusinessRelationshipSupplierBrand>;
  businessRelationshipSupplierChainHash: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deliveryTerm: Maybe<Scalars['Int']['output']>;
  deliveryTermMax: Maybe<Scalars['Int']['output']>;
  deliveryTermMin: Maybe<Scalars['Int']['output']>;
  fromCustomerWorkspaceProduct: Maybe<CustomerWorkspaceProduct>;
  fromCustomerWorkspaceProductBrand: Maybe<BusinessBrand>;
  fromCustomerWorkspaceProductMpn: Maybe<Scalars['String']['output']>;
  fromCustomerWorkspaceProductStatus: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  lastOrderedProduct: Maybe<OrderProduct>;
  lastProductRequest: Maybe<CustomerRequestProduct>;
  orderedAt: Maybe<Scalars['DateTime']['output']>;
  price: Maybe<Money>;
  product: Maybe<Product>;
  productMpn: Maybe<Scalars['String']['output']>;
  productStatus: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
  requestProducts: Maybe<Array<Maybe<CustomerRequestProduct>>>;
  searchedData: Maybe<SearchedData>;
  sort: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['String']['output']>;
  total: Maybe<Money>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type Dimensions = {
  __typename?: 'Dimensions';
  depth: Scalars['Decimal']['output'];
  height: Scalars['Decimal']['output'];
  isOverSize: Scalars['Boolean']['output'];
  isOverVolume: Scalars['Boolean']['output'];
  unit: Scalars['String']['output'];
  volume: Scalars['Decimal']['output'];
  width: Scalars['Decimal']['output'];
};

export type Discount = {
  __typename?: 'Discount';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  dateTimeFrom: Maybe<Scalars['DateTime']['output']>;
  dateTimeTo: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  filter: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  mathOperator: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  value: Maybe<Scalars['Int']['output']>;
};

export type Document = {
  __typename?: 'Document';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  files: Maybe<Array<Maybe<File>>>;
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  order: Maybe<Order>;
  status: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type Employee = {
  __typename?: 'Employee';
  business: Maybe<Business>;
  businessAccess: Maybe<Array<Maybe<EmployeeBusinessAccess>>>;
  businessAccessGroups: Maybe<Array<Maybe<EmployeeBusinessAccessGroup>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  defaultAccessGroup: Maybe<EmployeeBusinessAccessGroup>;
  email: Maybe<Scalars['String']['output']>;
  esteriolId: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['String']['output']>;
  location: Maybe<WarehouseLocation>;
  name: Maybe<Scalars['String']['output']>;
  notifications: Maybe<Array<Maybe<EmployeeNotification>>>;
  permissions: Maybe<Array<Maybe<EmployeePermission>>>;
  phone: Maybe<Scalars['String']['output']>;
  preferences: Maybe<Array<Maybe<EmployeePreference>>>;
  role: Maybe<Role>;
  saasClient: Maybe<SaasClient>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  warehouseCode: Maybe<Scalars['String']['output']>;
  warehouseCodeCreatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type EmployeeBusinessAccess = {
  __typename?: 'EmployeeBusinessAccess';
  business: Maybe<Business>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  employee: Maybe<Employee>;
  id: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type EmployeeBusinessAccessGroup = {
  __typename?: 'EmployeeBusinessAccessGroup';
  accessGroupBusinesses: Maybe<Array<Maybe<EmployeeBusinessAccessGroupBusiness>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  employee: Maybe<Employee>;
  id: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type EmployeeBusinessAccessGroupBusiness = {
  __typename?: 'EmployeeBusinessAccessGroupBusiness';
  business: Maybe<Business>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  employeeBusinessAccessGroup: Maybe<EmployeeBusinessAccessGroup>;
  id: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type EmployeeNotification = {
  __typename?: 'EmployeeNotification';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  employee: Maybe<Employee>;
  id: Maybe<Scalars['String']['output']>;
  key: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  value: Maybe<Scalars['Boolean']['output']>;
};

export type EmployeePermission = {
  __typename?: 'EmployeePermission';
  action: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  employee: Maybe<Employee>;
  id: Maybe<Scalars['String']['output']>;
  permission: Maybe<Permission>;
  role: Maybe<Role>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type EmployeePreference = Preference & {
  __typename?: 'EmployeePreference';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  employee: Maybe<Employee>;
  id: Maybe<Scalars['String']['output']>;
  key: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type EventProductToStock = WarehouseEvent & {
  __typename?: 'EventProductToStock';
  action_type: Maybe<Scalars['Int']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  employee: Maybe<Employee>;
  id: Maybe<Scalars['String']['output']>;
  location: Maybe<WarehouseLocation>;
  product: Maybe<Product>;
  quantity: Maybe<Scalars['Int']['output']>;
  shelf: Maybe<WarehouseShelf>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  waybillProduct: Maybe<WarehouseWaybillProduct>;
};

export type FeaturedBrand = {
  __typename?: 'FeaturedBrand';
  brand: Maybe<BusinessBrand>;
  id: Maybe<Scalars['String']['output']>;
  salesChannel: Maybe<SalesChannel>;
};

export type File = {
  __typename?: 'File';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  document: Maybe<Document>;
  ext: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  key: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  uploadedFile: Maybe<UploadedFile>;
};

export type FilterInput = {
  _isFreeText?: InputMaybe<Scalars['Boolean']['input']>;
  _key?: InputMaybe<Scalars['String']['input']>;
  func?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  isExcluded?: InputMaybe<Scalars['Boolean']['input']>;
  op?: InputMaybe<Scalars['String']['input']>;
  prop?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Invoice = {
  business: Maybe<Business>;
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  document: Maybe<Document>;
  documentLanguage: Maybe<Scalars['String']['output']>;
  esteriolId: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoiceTemplate: Maybe<Scalars['String']['output']>;
  logPayments: Maybe<Array<Maybe<PaymentLog>>>;
  modifiedBy: Maybe<Employee>;
  name: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['Int']['output']>;
  payment: Maybe<Payment>;
  paymentType: Maybe<Scalars['String']['output']>;
  payments: Maybe<Array<Maybe<Payment>>>;
  totals: Maybe<Array<Maybe<InvoiceTotal>>>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};


export type InvoicePaymentArgs = {
  type: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceCoupon = {
  __typename?: 'InvoiceCoupon';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  customerInvoice: Maybe<InvoiceCustomer>;
  id: Maybe<Scalars['String']['output']>;
  orderCoupon: Maybe<OrderCoupon>;
  total: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type InvoiceCreditNote = Invoice & {
  __typename?: 'InvoiceCreditNote';
  business: Maybe<Business>;
  comment: Maybe<Scalars['String']['output']>;
  coupons: Maybe<Array<Maybe<CreditNoteCoupon>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  customer: Maybe<Customer>;
  document: Maybe<Document>;
  documentLanguage: Maybe<Scalars['String']['output']>;
  dueDate: Maybe<Scalars['DateTime']['output']>;
  esteriolId: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoiceTemplate: Maybe<Scalars['String']['output']>;
  logPayments: Maybe<Array<Maybe<PaymentLog>>>;
  modifiedBy: Maybe<Employee>;
  name: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['Int']['output']>;
  orderProducts: Maybe<Array<Maybe<OrderProductAbstract>>>;
  payment: Maybe<Payment>;
  paymentType: Maybe<Scalars['String']['output']>;
  payments: Maybe<Array<Maybe<Payment>>>;
  sentAt: Maybe<Scalars['DateTime']['output']>;
  totalWeight: Maybe<Weight>;
  totals: Maybe<Array<Maybe<InvoiceTotal>>>;
  tracking: Maybe<ShippingTracking>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};


export type InvoiceCreditNotePaymentArgs = {
  type: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceCustomer = Invoice & {
  __typename?: 'InvoiceCustomer';
  business: Maybe<Business>;
  comment: Maybe<Scalars['String']['output']>;
  coupons: Maybe<Array<Maybe<InvoiceCoupon>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  customer: Maybe<Customer>;
  document: Maybe<Document>;
  documentLanguage: Maybe<Scalars['String']['output']>;
  dueDate: Maybe<Scalars['DateTime']['output']>;
  esteriolId: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoiceTemplate: Maybe<Scalars['String']['output']>;
  logPayments: Maybe<Array<Maybe<PaymentLog>>>;
  modifiedBy: Maybe<Employee>;
  name: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['Int']['output']>;
  orderProducts: Maybe<Array<Maybe<OrderProductAbstract>>>;
  paidAt: Maybe<Scalars['DateTime']['output']>;
  payment: Maybe<Payment>;
  paymentType: Maybe<Scalars['String']['output']>;
  payments: Maybe<Array<Maybe<Payment>>>;
  sentAt: Maybe<Scalars['DateTime']['output']>;
  specification: Maybe<Specification>;
  status: Maybe<Scalars['String']['output']>;
  totalWeight: Maybe<Weight>;
  totals: Maybe<Array<Maybe<InvoiceTotal>>>;
  tracking: Maybe<ShippingTracking>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};


export type InvoiceCustomerPaymentArgs = {
  type: InputMaybe<Scalars['String']['input']>;
};

export type InvoicePaymentAdyen = Payment & {
  __typename?: 'InvoicePaymentAdyen';
  amount: Maybe<Money>;
  amountAuthorized: Maybe<Money>;
  amountCapture: Maybe<Money>;
  captureError: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoice: Maybe<Invoice>;
  order: Maybe<Order>;
  paymentDetails: Maybe<Scalars['String']['output']>;
  paymentMethod: Maybe<Scalars['String']['output']>;
  pspReference: Maybe<Scalars['String']['output']>;
  reference: Maybe<Scalars['String']['output']>;
  refundAmount: Maybe<Money>;
  refusalReason: Maybe<Scalars['String']['output']>;
  refusalReasonCode: Maybe<Scalars['String']['output']>;
  resultCode: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type InvoicePaymentBank = Payment & {
  __typename?: 'InvoicePaymentBank';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoice: Maybe<Invoice>;
  order: Maybe<Order>;
  paymentDetails: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type InvoiceProductsList = Invoice & {
  __typename?: 'InvoiceProductsList';
  business: Maybe<Business>;
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  document: Maybe<Document>;
  documentLanguage: Maybe<Scalars['String']['output']>;
  employee: Maybe<Employee>;
  esteriolId: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoiceTemplate: Maybe<Scalars['String']['output']>;
  logPayments: Maybe<Array<Maybe<PaymentLog>>>;
  modifiedBy: Maybe<Employee>;
  name: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['Int']['output']>;
  order: Maybe<Order>;
  payment: Maybe<Payment>;
  paymentType: Maybe<Scalars['String']['output']>;
  payments: Maybe<Array<Maybe<Payment>>>;
  totals: Maybe<Array<Maybe<InvoiceTotal>>>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};


export type InvoiceProductsListPaymentArgs = {
  type: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceProforma = Invoice & {
  __typename?: 'InvoiceProforma';
  business: Maybe<Business>;
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  customer: Maybe<Customer>;
  document: Maybe<Document>;
  documentLanguage: Maybe<Scalars['String']['output']>;
  dueDate: Maybe<Scalars['DateTime']['output']>;
  esteriolId: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoiceTemplate: Maybe<Scalars['String']['output']>;
  logPayments: Maybe<Array<Maybe<PaymentLog>>>;
  modifiedBy: Maybe<Employee>;
  name: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['Int']['output']>;
  order: Maybe<Order>;
  orderProducts: Maybe<Array<Maybe<OrderProduct>>>;
  payment: Maybe<Payment>;
  paymentType: Maybe<Scalars['String']['output']>;
  payments: Maybe<Array<Maybe<Payment>>>;
  sentAt: Maybe<Scalars['DateTime']['output']>;
  totalWeight: Maybe<Weight>;
  totals: Maybe<Array<Maybe<InvoiceTotal>>>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};


export type InvoiceProformaPaymentArgs = {
  type: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceTotal = {
  __typename?: 'InvoiceTotal';
  additionalInfo: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  sequence: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  value: Maybe<Money>;
};

export type MarkupPrice = {
  __typename?: 'MarkupPrice';
  ProductPrice: Maybe<ProductPrice>;
  chainHash: Maybe<Scalars['String']['output']>;
  customerMarkup: Maybe<Scalars['Int']['output']>;
  deliveryTermExpressMax: Maybe<Scalars['Int']['output']>;
  deliveryTermExpressMin: Maybe<Scalars['Int']['output']>;
  deliveryTermStandardMax: Maybe<Scalars['Int']['output']>;
  deliveryTermStandardMin: Maybe<Scalars['Int']['output']>;
  hasCustomerMarkup: Maybe<Scalars['Boolean']['output']>;
  isEnabledCustomerMarkup: Maybe<Scalars['Boolean']['output']>;
  markup: Maybe<Scalars['Int']['output']>;
  price: Maybe<Money>;
  purchasePrice: Maybe<Money>;
  relationSupplierHash: Maybe<Scalars['String']['output']>;
  relationshipSupplierBrand: Maybe<BusinessRelationshipSupplierBrand>;
  totalMarkup: Maybe<Scalars['Int']['output']>;
};

export type MinimalShippingPayload = {
  __typename?: 'MinimalShippingPayload';
  country: Maybe<Country>;
  shippingMethod: Maybe<ShippingMethod>;
};

export type Money = {
  __typename?: 'Money';
  amount: Scalars['Decimal']['output'];
  cents: Scalars['String']['output'];
  currency: Scalars['String']['output'];
};

export type Order = {
  __typename?: 'Order';
  aggregatedDocuments: Maybe<Array<Maybe<Document>>>;
  aggregatedOrderTotals: Maybe<Array<Maybe<AggregatedOrderTotal>>>;
  archived: Maybe<Scalars['Boolean']['output']>;
  billingAddress: Maybe<Address>;
  billingAddressHash: Maybe<Scalars['String']['output']>;
  billingAddressLine1: Maybe<Scalars['String']['output']>;
  billingAddressLine2: Maybe<Scalars['String']['output']>;
  billingCity: Maybe<Scalars['String']['output']>;
  billingCompanyName: Maybe<Scalars['String']['output']>;
  billingCompanyReg: Maybe<Scalars['String']['output']>;
  billingCompanyVat: Maybe<Scalars['String']['output']>;
  billingCountry: Maybe<Country>;
  billingFirstName: Maybe<Scalars['String']['output']>;
  billingLastName: Maybe<Scalars['String']['output']>;
  billingNickname: Maybe<Scalars['String']['output']>;
  billingPhone: Maybe<Scalars['String']['output']>;
  billingRegion: Maybe<Scalars['String']['output']>;
  billingSameAsShipping: Maybe<Scalars['Boolean']['output']>;
  billingVatData: Maybe<Vat>;
  billingZip: Maybe<Scalars['String']['output']>;
  brands: Maybe<Array<Maybe<BusinessBrand>>>;
  brandsWeight: Maybe<Array<Maybe<BrandWeight>>>;
  business: Maybe<Business>;
  cart: Maybe<Cart>;
  cartId: Maybe<Scalars['String']['output']>;
  checkoutError: Maybe<Scalars['String']['output']>;
  checkoutStatus: Maybe<Scalars['String']['output']>;
  childOrders: Maybe<Array<Maybe<Order>>>;
  comment: Maybe<Scalars['String']['output']>;
  completion: Maybe<Scalars['Int']['output']>;
  coupons: Maybe<Array<Maybe<OrderCoupon>>>;
  createFromOrderId: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  currencyCode: Maybe<Scalars['String']['output']>;
  currencyRate: Maybe<Scalars['Int']['output']>;
  customer: Maybe<Customer>;
  customerEmail: Maybe<Scalars['String']['output']>;
  displayId: Maybe<Scalars['String']['output']>;
  document: Maybe<Document>;
  domain: Maybe<Scalars['String']['output']>;
  employee: Maybe<Employee>;
  id: Maybe<Scalars['String']['output']>;
  incoterms: Maybe<Scalars['String']['output']>;
  invoiceProductsList: Maybe<Array<Maybe<InvoiceProductsList>>>;
  invoiceReference: Maybe<Scalars['String']['output']>;
  isPacked: Maybe<Scalars['Boolean']['output']>;
  isPaid: Maybe<Scalars['Boolean']['output']>;
  isShippingInsuranceApplied: Maybe<Scalars['Boolean']['output']>;
  isTransitIncluded: Maybe<Scalars['Boolean']['output']>;
  language: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Employee>;
  name: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['Int']['output']>;
  packStatus: Maybe<Scalars['String']['output']>;
  parent: Maybe<Order>;
  payReference: Maybe<Scalars['String']['output']>;
  payment: Maybe<Payment>;
  paymentFrom: Maybe<Scalars['String']['output']>;
  paymentType: Maybe<Scalars['String']['output']>;
  payments: Maybe<Array<Maybe<Payment>>>;
  products: Maybe<Array<Maybe<OrderProduct>>>;
  profitAmount: Maybe<Money>;
  profitability: Maybe<Scalars['Int']['output']>;
  proformas: Maybe<Array<Maybe<InvoiceProforma>>>;
  purchasingTotal: Maybe<Money>;
  secondaryProducts: Maybe<Array<Maybe<OrderProductSecondary>>>;
  sentLog: Maybe<Array<Maybe<OrderSend>>>;
  shippingAddress: Maybe<Address>;
  shippingAddressHash: Maybe<Scalars['String']['output']>;
  shippingAddressLine1: Maybe<Scalars['String']['output']>;
  shippingAddressLine2: Maybe<Scalars['String']['output']>;
  shippingCity: Maybe<Scalars['String']['output']>;
  shippingCompanyName: Maybe<Scalars['String']['output']>;
  shippingCompanyReg: Maybe<Scalars['String']['output']>;
  shippingCompanyVat: Maybe<Scalars['String']['output']>;
  shippingCountry: Maybe<Country>;
  shippingEstimatedAt: Maybe<Scalars['DateTime']['output']>;
  shippingExpenses: Maybe<Money>;
  shippingFirstName: Maybe<Scalars['String']['output']>;
  shippingLastName: Maybe<Scalars['String']['output']>;
  shippingMethod: Maybe<Scalars['String']['output']>;
  shippingNickname: Maybe<Scalars['String']['output']>;
  shippingPhone: Maybe<Scalars['String']['output']>;
  shippingRegion: Maybe<Scalars['String']['output']>;
  shippingSelfPickup: Maybe<Scalars['Boolean']['output']>;
  shippingSupplier: Maybe<Scalars['String']['output']>;
  shippingVatData: Maybe<Vat>;
  shippingZip: Maybe<Scalars['String']['output']>;
  shortDisplayId: Maybe<Scalars['String']['output']>;
  sourceSystem: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  totalPackedQuantity: Maybe<Scalars['Int']['output']>;
  totalQuantity: Maybe<Scalars['Int']['output']>;
  totalWeight: Maybe<Weight>;
  totals: Maybe<Array<Maybe<OrderTotal>>>;
  totalsOrdersCountry: Maybe<Scalars['Int']['output']>;
  transitAddress: Maybe<OrderAddress>;
  transitCountry: Maybe<Country>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  utmCampaign: Maybe<Scalars['String']['output']>;
  utmMedium: Maybe<Scalars['String']['output']>;
  utmSource: Maybe<Scalars['String']['output']>;
  vatCoefficient: Maybe<Scalars['Int']['output']>;
  vatCountryCode: Maybe<Scalars['String']['output']>;
  waybillProducts: Maybe<Array<Maybe<WarehouseWaybillProduct>>>;
};


export type OrderPaymentArgs = {
  type: InputMaybe<Scalars['String']['input']>;
};

export type OrderAddress = {
  addressLine1: Maybe<Scalars['String']['output']>;
  addressLine2: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  companyReg: Maybe<Scalars['String']['output']>;
  companyVat: Maybe<Scalars['String']['output']>;
  country: Maybe<Country>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  nickname: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

export type OrderCoupon = {
  __typename?: 'OrderCoupon';
  cartFilter: Maybe<Scalars['String']['output']>;
  cartProductFilter: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['String']['output']>;
  coupon: Maybe<Coupon>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  creditNoteCoupons: Maybe<Array<Maybe<CreditNoteCoupon>>>;
  customer: Maybe<Customer>;
  discountType: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoiceCoupons: Maybe<Array<Maybe<InvoiceCoupon>>>;
  isValid: Maybe<Scalars['Boolean']['output']>;
  mathOperator: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  order: Maybe<Order>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  value: Maybe<Scalars['Int']['output']>;
};

export type OrderPaymentAdyen = Payment & {
  __typename?: 'OrderPaymentAdyen';
  amount: Maybe<Money>;
  amountAuthorized: Maybe<Money>;
  amountCapture: Maybe<Money>;
  captureError: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoice: Maybe<Invoice>;
  order: Maybe<Order>;
  paymentDetails: Maybe<Scalars['String']['output']>;
  paymentMethod: Maybe<Scalars['String']['output']>;
  paymentStatus: Maybe<Scalars['String']['output']>;
  pspReference: Maybe<Scalars['String']['output']>;
  reference: Maybe<Scalars['String']['output']>;
  refundAmount: Maybe<Money>;
  refusalReason: Maybe<Scalars['String']['output']>;
  refusalReasonCode: Maybe<Scalars['String']['output']>;
  resultCode: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type OrderPaymentBank = Payment & {
  __typename?: 'OrderPaymentBank';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoice: Maybe<Invoice>;
  order: Maybe<Order>;
  paymentDetails: Maybe<Scalars['String']['output']>;
  paymentStatus: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type OrderPaymentPaypal = Payment & {
  __typename?: 'OrderPaymentPaypal';
  amount: Maybe<Money>;
  authorizationId: Maybe<Scalars['String']['output']>;
  authorizationStatus: Maybe<Scalars['String']['output']>;
  captureError: Maybe<Scalars['String']['output']>;
  captureId: Maybe<Scalars['String']['output']>;
  captureReason: Maybe<Scalars['String']['output']>;
  captureStatus: Maybe<Scalars['String']['output']>;
  checkoutStatus: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  customId: Maybe<Scalars['String']['output']>;
  failedIssue: Maybe<Scalars['String']['output']>;
  failedName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoice: Maybe<Invoice>;
  order: Maybe<Order>;
  payerId: Maybe<Scalars['String']['output']>;
  paymentDetails: Maybe<Scalars['String']['output']>;
  paymentStatus: Maybe<Scalars['String']['output']>;
  reference: Maybe<Scalars['String']['output']>;
  refundAmount: Maybe<Money>;
  refundId: Maybe<Scalars['String']['output']>;
  refundStatus: Maybe<Scalars['String']['output']>;
  transactionId: Maybe<Scalars['String']['output']>;
  transactionStatus: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type OrderProduct = OrderProductAbstract & {
  __typename?: 'OrderProduct';
  actualProduct: Maybe<Product>;
  availableBrsbs: Maybe<Array<Maybe<AvailableBrsb>>>;
  brand: Maybe<BusinessBrand>;
  businessRelationshipSupplierChainHash: Maybe<Scalars['String']['output']>;
  createFromOrderProductId: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  customerBoxProduct: Maybe<CustomerBoxProduct>;
  customerInvoice: Maybe<InvoiceCustomer>;
  depositAmount: Maybe<Money>;
  desiredQuantity: Maybe<Scalars['Int']['output']>;
  dimensions: Maybe<Dimensions>;
  discount: Maybe<Scalars['Int']['output']>;
  exchangeBrand: Maybe<BusinessBrand>;
  exchangeProduct: Maybe<Product>;
  expectedArrivalDate: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoiceCreditNote: Maybe<InvoiceCreditNote>;
  isInvoiceable: Maybe<Scalars['Boolean']['output']>;
  modifiedBy: Maybe<Employee>;
  number: Maybe<Scalars['Int']['output']>;
  order: Maybe<Order>;
  orderSend: Maybe<OrderSend>;
  originalPurchasePriceMoney: Maybe<Money>;
  packedAt: Maybe<Scalars['DateTime']['output']>;
  packedQuantity: Maybe<Scalars['Int']['output']>;
  price: Maybe<Money>;
  product: Maybe<Product>;
  profitAmount: Maybe<Money>;
  proformaInvoice: Maybe<InvoiceProforma>;
  purchasePrice: Maybe<Money>;
  quantity: Maybe<Scalars['Int']['output']>;
  relationSupplierHash: Maybe<Scalars['String']['output']>;
  relationshipSupplierBrand: Maybe<BusinessRelationshipSupplierBrand>;
  secondaryProducts: Maybe<Array<Maybe<OrderProductSecondary>>>;
  stockQuantity: Maybe<Scalars['Int']['output']>;
  stockReserves: Maybe<Array<Maybe<WarehouseReserve>>>;
  totalPrice: Maybe<Money>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  waybillProductOrderProducts: Maybe<Array<Maybe<WarehouseWaybillProductOrderProduct>>>;
  weight: Maybe<Weight>;
  weightInKg: Maybe<Scalars['Float']['output']>;
};

export type OrderProductAbstract = {
  actualProduct: Maybe<Product>;
  availableBrsbs: Maybe<Array<Maybe<AvailableBrsb>>>;
  brand: Maybe<BusinessBrand>;
  businessRelationshipSupplierChainHash: Maybe<Scalars['String']['output']>;
  createFromOrderProductId: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  customerBoxProduct: Maybe<CustomerBoxProduct>;
  customerInvoice: Maybe<InvoiceCustomer>;
  depositAmount: Maybe<Money>;
  desiredQuantity: Maybe<Scalars['Int']['output']>;
  dimensions: Maybe<Dimensions>;
  discount: Maybe<Scalars['Int']['output']>;
  exchangeBrand: Maybe<BusinessBrand>;
  exchangeProduct: Maybe<Product>;
  expectedArrivalDate: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoiceCreditNote: Maybe<InvoiceCreditNote>;
  isInvoiceable: Maybe<Scalars['Boolean']['output']>;
  modifiedBy: Maybe<Employee>;
  number: Maybe<Scalars['Int']['output']>;
  order: Maybe<Order>;
  orderSend: Maybe<OrderSend>;
  originalPurchasePriceMoney: Maybe<Money>;
  packedAt: Maybe<Scalars['DateTime']['output']>;
  packedQuantity: Maybe<Scalars['Int']['output']>;
  price: Maybe<Money>;
  product: Maybe<Product>;
  profitAmount: Maybe<Money>;
  proformaInvoice: Maybe<InvoiceProforma>;
  purchasePrice: Maybe<Money>;
  quantity: Maybe<Scalars['Int']['output']>;
  relationSupplierHash: Maybe<Scalars['String']['output']>;
  relationshipSupplierBrand: Maybe<BusinessRelationshipSupplierBrand>;
  stockQuantity: Maybe<Scalars['Int']['output']>;
  stockReserves: Maybe<Array<Maybe<WarehouseReserve>>>;
  totalPrice: Maybe<Money>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  waybillProductOrderProducts: Maybe<Array<Maybe<WarehouseWaybillProductOrderProduct>>>;
  weight: Maybe<Weight>;
  weightInKg: Maybe<Scalars['Float']['output']>;
};

export type OrderProductSecondary = OrderProductAbstract & {
  __typename?: 'OrderProductSecondary';
  actualProduct: Maybe<Product>;
  availableBrsbs: Maybe<Array<Maybe<AvailableBrsb>>>;
  brand: Maybe<BusinessBrand>;
  businessRelationshipSupplierChainHash: Maybe<Scalars['String']['output']>;
  createFromOrderProductId: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  customerBoxProduct: Maybe<CustomerBoxProduct>;
  customerInvoice: Maybe<InvoiceCustomer>;
  depositAmount: Maybe<Money>;
  desiredQuantity: Maybe<Scalars['Int']['output']>;
  dimensions: Maybe<Dimensions>;
  discount: Maybe<Scalars['Int']['output']>;
  exchangeBrand: Maybe<BusinessBrand>;
  exchangeProduct: Maybe<Product>;
  expectedArrivalDate: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoiceCreditNote: Maybe<InvoiceCreditNote>;
  isInvoiceable: Maybe<Scalars['Boolean']['output']>;
  modifiedBy: Maybe<Employee>;
  number: Maybe<Scalars['Int']['output']>;
  order: Maybe<Order>;
  orderSend: Maybe<OrderSend>;
  originalOrderProduct: Maybe<OrderProduct>;
  originalPurchasePriceMoney: Maybe<Money>;
  packedAt: Maybe<Scalars['DateTime']['output']>;
  packedQuantity: Maybe<Scalars['Int']['output']>;
  price: Maybe<Money>;
  product: Maybe<Product>;
  profitAmount: Maybe<Money>;
  proformaInvoice: Maybe<InvoiceProforma>;
  purchasePrice: Maybe<Money>;
  quantity: Maybe<Scalars['Int']['output']>;
  relationSupplierHash: Maybe<Scalars['String']['output']>;
  relationshipSupplierBrand: Maybe<BusinessRelationshipSupplierBrand>;
  stockQuantity: Maybe<Scalars['Int']['output']>;
  stockReserves: Maybe<Array<Maybe<WarehouseReserve>>>;
  totalPrice: Maybe<Money>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  waybillProductOrderProducts: Maybe<Array<Maybe<WarehouseWaybillProductOrderProduct>>>;
  weight: Maybe<Weight>;
  weightInKg: Maybe<Scalars['Float']['output']>;
};

export type OrderSend = {
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  order: Maybe<Order>;
  orderProducts: Maybe<Array<Maybe<OrderProduct>>>;
  sender: Maybe<Employee>;
  sentAt: Maybe<Scalars['DateTime']['output']>;
  sentToBusinessName: Maybe<Scalars['String']['output']>;
  toBusiness: Maybe<Business>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type OrderTotal = {
  __typename?: 'OrderTotal';
  additionalInfo: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  sequence: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  value: Maybe<Money>;
};

export type Pagination = {
  __typename?: 'Pagination';
  current: Maybe<Scalars['Int']['output']>;
  limit: Maybe<Scalars['Int']['output']>;
  totalCount: Maybe<Scalars['Int']['output']>;
  totalPages: Maybe<Scalars['Int']['output']>;
};

export type Parameter = {
  __typename?: 'Parameter';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  nameDe: Maybe<Scalars['String']['output']>;
  nameEn: Maybe<Scalars['String']['output']>;
  nameEs: Maybe<Scalars['String']['output']>;
  nameFr: Maybe<Scalars['String']['output']>;
  namePl: Maybe<Scalars['String']['output']>;
  nameRu: Maybe<Scalars['String']['output']>;
  typeDe: Maybe<Scalars['String']['output']>;
  typeEn: Maybe<Scalars['String']['output']>;
  typeEs: Maybe<Scalars['String']['output']>;
  typeFr: Maybe<Scalars['String']['output']>;
  typePl: Maybe<Scalars['String']['output']>;
  typeRu: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type Payment = {
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoice: Maybe<Invoice>;
  order: Maybe<Order>;
  paymentDetails: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentLog = {
  __typename?: 'PaymentLog';
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  employee: Maybe<Employee>;
  hash: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  invoice: Maybe<Invoice>;
  invoicePaymentAdyen: Maybe<InvoicePaymentAdyen>;
  invoicePaymentBank: Maybe<InvoicePaymentBank>;
  invoicePaymentPaypal: Maybe<OrderPaymentPaypal>;
  order: Maybe<Order>;
  orderPaymentAdyen: Maybe<OrderPaymentAdyen>;
  orderPaymentBank: Maybe<OrderPaymentBank>;
  orderPaymentPaypal: Maybe<OrderPaymentPaypal>;
  request: Maybe<Scalars['String']['output']>;
  response: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  transactionId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  brands: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  details: Maybe<Array<Maybe<PaymentMethodDetail>>>;
  name: Maybe<Scalars['String']['output']>;
  processor: Maybe<Scalars['String']['output']>;
  supportsRecurring: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodDetail = {
  __typename?: 'PaymentMethodDetail';
  key: Maybe<Scalars['String']['output']>;
  optional: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodGroup = {
  __typename?: 'PaymentMethodGroup';
  name: Maybe<Scalars['String']['output']>;
  types: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PaymentMethodsList = {
  __typename?: 'PaymentMethodsList';
  groups: Maybe<Array<Maybe<PaymentMethodGroup>>>;
  paymentMethods: Maybe<Array<Maybe<PaymentMethod>>>;
};

export type Permission = {
  __typename?: 'Permission';
  id: Maybe<Scalars['String']['output']>;
  moduleName: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type Preference = {
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  key: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type Product = {
  __typename?: 'Product';
  analogues: Maybe<Array<Maybe<Product>>>;
  brand: Maybe<BusinessBrand>;
  categoryTypes: Maybe<Array<Maybe<ProductCategoryType>>>;
  countryOfOrigin: Maybe<Country>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  depth: Maybe<Scalars['Int']['output']>;
  dimensions: Maybe<Dimensions>;
  discount: Maybe<Discount>;
  ean: Maybe<Scalars['String']['output']>;
  esteriolId: Maybe<Scalars['Int']['output']>;
  exchangeMpn: Maybe<Scalars['String']['output']>;
  exchangedFrom: Maybe<Array<Maybe<ProductExchange>>>;
  exchanges: Maybe<Array<Maybe<ProductExchange>>>;
  group: Maybe<ProductGroup>;
  height: Maybe<Scalars['Int']['output']>;
  hsCode: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  info: Maybe<ProductInfo>;
  keepFlat: Maybe<Scalars['Boolean']['output']>;
  minimalOrderQuantity: Maybe<Scalars['Int']['output']>;
  modifiedBy: Maybe<Employee>;
  mpn: Maybe<Scalars['String']['output']>;
  mpnAnalyzed: Maybe<Scalars['String']['output']>;
  mpnExist: Maybe<Scalars['String']['output']>;
  mpnFormatted: Maybe<Scalars['String']['output']>;
  originals: Maybe<Array<Maybe<ProductExchange>>>;
  price: Maybe<Money>;
  prices: Maybe<Array<Maybe<MarkupPrice>>>;
  productAssets: Maybe<Array<Maybe<ProductAsset>>>;
  productCars: Maybe<Array<Maybe<ProductCar>>>;
  productImages: Maybe<Array<Maybe<ProductImage>>>;
  productParameters: Maybe<Array<Maybe<ProductParameter>>>;
  productPrices: Maybe<Array<Maybe<ProductPrice>>>;
  productType: Maybe<Scalars['String']['output']>;
  requestProducts: Maybe<Array<Maybe<CustomerRequestProduct>>>;
  sku: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  weight: Maybe<Weight>;
  weightInKg: Maybe<Scalars['String']['output']>;
  width: Maybe<Scalars['Int']['output']>;
};

export type ProductAsset = {
  __typename?: 'ProductAsset';
  id: Maybe<Scalars['String']['output']>;
};

export type ProductCar = {
  __typename?: 'ProductCar';
  id: Maybe<Scalars['String']['output']>;
};

export type ProductCategoryType = {
  __typename?: 'ProductCategoryType';
  categoryType: Maybe<CategoryType>;
  id: Maybe<Scalars['String']['output']>;
  product: Maybe<Product>;
};

export type ProductExchange = {
  __typename?: 'ProductExchange';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  id: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Employee>;
  product: Maybe<Product>;
  toProduct: Maybe<Product>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type ProductGroup = {
  __typename?: 'ProductGroup';
  brand: Maybe<BusinessBrand>;
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type ProductImage = {
  __typename?: 'ProductImage';
  alt: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isMain: Maybe<Scalars['Boolean']['output']>;
  link: Maybe<Scalars['String']['output']>;
};

export type ProductInfo = {
  __typename?: 'ProductInfo';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  descriptionDe: Maybe<Scalars['String']['output']>;
  descriptionEn: Maybe<Scalars['String']['output']>;
  descriptionEs: Maybe<Scalars['String']['output']>;
  descriptionFr: Maybe<Scalars['String']['output']>;
  descriptionPl: Maybe<Scalars['String']['output']>;
  descriptionRu: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  metaDescriptionDe: Maybe<Scalars['String']['output']>;
  metaDescriptionEn: Maybe<Scalars['String']['output']>;
  metaDescriptionEs: Maybe<Scalars['String']['output']>;
  metaDescriptionFr: Maybe<Scalars['String']['output']>;
  metaDescriptionPl: Maybe<Scalars['String']['output']>;
  metaDescriptionRu: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Employee>;
  nameDe: Maybe<Scalars['String']['output']>;
  nameEn: Maybe<Scalars['String']['output']>;
  nameEs: Maybe<Scalars['String']['output']>;
  nameFr: Maybe<Scalars['String']['output']>;
  namePl: Maybe<Scalars['String']['output']>;
  nameRu: Maybe<Scalars['String']['output']>;
  slugDe: Maybe<Scalars['String']['output']>;
  slugEn: Maybe<Scalars['String']['output']>;
  slugEs: Maybe<Scalars['String']['output']>;
  slugFr: Maybe<Scalars['String']['output']>;
  slugPl: Maybe<Scalars['String']['output']>;
  slugRu: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type ProductParameter = {
  __typename?: 'ProductParameter';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  id: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Employee>;
  parameter: Maybe<Parameter>;
  product: Maybe<Product>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  valueDe: Maybe<Scalars['String']['output']>;
  valueEn: Maybe<Scalars['String']['output']>;
  valueEs: Maybe<Scalars['String']['output']>;
  valueFr: Maybe<Scalars['String']['output']>;
  valuePl: Maybe<Scalars['String']['output']>;
  valueRu: Maybe<Scalars['String']['output']>;
};

export type ProductPrice = {
  __typename?: 'ProductPrice';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  customerMarkup: Maybe<Scalars['Int']['output']>;
  depositPrice: Maybe<Money>;
  distributorPrice: Maybe<Money>;
  id: Maybe<Scalars['String']['output']>;
  importPrice: Maybe<Money>;
  markup: Maybe<Scalars['Int']['output']>;
  modifiedBy: Maybe<Employee>;
  price: Maybe<Money>;
  purchasePrice: Maybe<Money>;
  supplier: Maybe<BusinessSupplier>;
  totalMarkup: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type ProductQueryInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type RegistrationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type ResetPasswordInput = {
  confirmedPassword?: InputMaybe<Scalars['String']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
};

export type Role = {
  __typename?: 'Role';
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type SaasClient = {
  __typename?: 'SaasClient';
  clientName: Maybe<Scalars['String']['output']>;
  country: Maybe<Country>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  domains: Maybe<Array<Maybe<SaasClientDomain>>>;
  email: Maybe<Scalars['String']['output']>;
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Employee>;
  name: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  salesChannels: Maybe<Array<Maybe<SalesChannel>>>;
  status: Maybe<Scalars['String']['output']>;
  trial: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type SaasClientDomain = {
  __typename?: 'SaasClientDomain';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  id: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Employee>;
  name: Maybe<Scalars['String']['output']>;
  saasClient: Maybe<SaasClient>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type SalesChannel = {
  __typename?: 'SalesChannel';
  brands: Maybe<Array<Maybe<BusinessBrand>>>;
  countries: Maybe<Array<Maybe<Country>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  currency: Maybe<Currency>;
  defaultCountry: Maybe<Country>;
  defaultLanguage: Maybe<Scalars['String']['output']>;
  distributor: Maybe<BusinessDistributor>;
  domainName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isAllBrandsAvailable: Maybe<Scalars['Boolean']['output']>;
  isAllCountriesAvailable: Maybe<Scalars['Boolean']['output']>;
  isAllSuppliersAvailable: Maybe<Scalars['Boolean']['output']>;
  modifiedBy: Maybe<Employee>;
  name: Maybe<Scalars['String']['output']>;
  paymentMethods: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  saasClient: Maybe<SaasClient>;
  shippingMethods: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status: Maybe<Scalars['String']['output']>;
  suppliers: Maybe<Array<Maybe<BusinessSupplier>>>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type SalesChannelOptions = {
  __typename?: 'SalesChannelOptions';
  countries: Maybe<Array<Maybe<Country>>>;
  currency: Maybe<Currency>;
  defaultLanguage: Scalars['String']['output'];
  domainName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  paymentMethods: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shippingMethods: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type: Scalars['String']['output'];
};

export type SearchedData = {
  __typename?: 'SearchedData';
  brands: Maybe<Array<Maybe<BusinessBrand>>>;
  code: Maybe<Scalars['String']['output']>;
  crossBrandName: Maybe<Scalars['String']['output']>;
};

export type SendRecoveryPasswordMailInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type ShippingMethod = {
  __typename?: 'ShippingMethod';
  currency: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  insurancePrice: Maybe<Money>;
  isInsured: Maybe<Scalars['Boolean']['output']>;
  leadTime: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price: Maybe<Money>;
  shippingSuppliers: Maybe<Array<Maybe<ShippingSupplier>>>;
  type: Maybe<Scalars['String']['output']>;
};

export type ShippingRateInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputMaybe<ShippingRateProductInput>>>;
};

export type ShippingRateProductInput = {
  chainHash: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type ShippingSupplier = {
  __typename?: 'ShippingSupplier';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ShippingTracking = {
  __typename?: 'ShippingTracking';
  customerInvoice: Maybe<InvoiceCustomer>;
  id: Maybe<Scalars['String']['output']>;
  invoiceCreditNote: Maybe<InvoiceCreditNote>;
  trackingNumber: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Specification = {
  __typename?: 'Specification';
  business: Maybe<Business>;
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  declarationNumber: Maybe<Scalars['String']['output']>;
  delivered: Scalars['Boolean']['output'];
  deliveryDate: Maybe<Scalars['DateTime']['output']>;
  documentsReadyDate: Maybe<Scalars['DateTime']['output']>;
  exportDeclaration: Scalars['Boolean']['output'];
  files: Maybe<Array<Maybe<File>>>;
  id: Maybe<Scalars['String']['output']>;
  invoices: Maybe<Array<Maybe<InvoiceCustomer>>>;
  number: Maybe<Scalars['Int']['output']>;
  packingType: Scalars['String']['output'];
  placeNumber: Scalars['Int']['output'];
  productsReadyDate: Maybe<Scalars['DateTime']['output']>;
  shippingDate: Scalars['DateTime']['output'];
  totalPrice: Maybe<Money>;
  totalWeight: Maybe<Weight>;
  transactionDate: Scalars['DateTime']['output'];
  type: Scalars['String']['output'];
  typeName: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type StaticPageContentInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type StaticPageContentType = {
  __typename?: 'StaticPageContentType';
  content: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pageName: Scalars['String']['output'];
};

export type SupplierLocation = {
  __typename?: 'SupplierLocation';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  id: Maybe<Scalars['String']['output']>;
  location: Maybe<WarehouseLocation>;
  modifiedBy: Maybe<Employee>;
  supplier: Maybe<BusinessSupplier>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type TopCategory = {
  __typename?: 'TopCategory';
  category: Maybe<Category>;
  id: Maybe<Scalars['String']['output']>;
  salesChannel: Maybe<SalesChannel>;
};

export type UploadedFile = {
  __typename?: 'UploadedFile';
  ext: Maybe<Scalars['String']['output']>;
  key: Maybe<Scalars['String']['output']>;
  signedUrl: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type UrlDataQueryInput = {
  url: Scalars['String']['input'];
};

export type Vat = {
  __typename?: 'Vat';
  country: Maybe<Country>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  lastValidationAt: Maybe<Scalars['DateTime']['output']>;
  number: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  valid: Maybe<Scalars['Boolean']['output']>;
  validationStatus: Maybe<Scalars['String']['output']>;
};

export type WarehouseEvent = {
  action_type: Maybe<Scalars['Int']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  employee: Maybe<Employee>;
  id: Maybe<Scalars['String']['output']>;
  location: Maybe<WarehouseLocation>;
  product: Maybe<Product>;
  quantity: Maybe<Scalars['Int']['output']>;
  shelf: Maybe<WarehouseShelf>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  waybillProduct: Maybe<WarehouseWaybillProduct>;
};

export type WarehouseImportProduct = {
  __typename?: 'WarehouseImportProduct';
  brand: Maybe<BusinessBrand>;
  brandName: Maybe<Scalars['String']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  id: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Employee>;
  mpn: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
  shelfName: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  stock: Maybe<WarehouseStock>;
  stockImport: Maybe<WarehouseStockImport>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type WarehouseLocation = {
  __typename?: 'WarehouseLocation';
  address: Maybe<Scalars['String']['output']>;
  business: Maybe<Business>;
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Country>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  default: Maybe<Scalars['Boolean']['output']>;
  employees: Maybe<Array<Maybe<Employee>>>;
  id: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Employee>;
  name: Maybe<Scalars['String']['output']>;
  shelves: Maybe<Array<Maybe<WarehouseShelf>>>;
  supplier: Maybe<BusinessSupplier>;
  supplierLocations: Maybe<Array<Maybe<SupplierLocation>>>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  waybills: Maybe<Array<Maybe<WarehouseWaybill>>>;
  zip: Maybe<Scalars['String']['output']>;
};

export type WarehouseReserve = {
  __typename?: 'WarehouseReserve';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  id: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Employee>;
  orderProduct: Maybe<OrderProduct>;
  quantity: Maybe<Scalars['Int']['output']>;
  stock: Maybe<WarehouseStock>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type WarehouseShelf = {
  __typename?: 'WarehouseShelf';
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  id: Maybe<Scalars['String']['output']>;
  location: Maybe<WarehouseLocation>;
  modifiedBy: Maybe<Employee>;
  name: Maybe<Scalars['String']['output']>;
  stocks: Maybe<Array<Maybe<WarehouseStock>>>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type WarehouseStock = {
  __typename?: 'WarehouseStock';
  availableQuantity: Maybe<Scalars['Int']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  eventProductToStock: Maybe<Array<Maybe<EventProductToStock>>>;
  id: Maybe<Scalars['String']['output']>;
  importProducts: Maybe<Array<Maybe<WarehouseImportProduct>>>;
  import_hash: Maybe<Scalars['String']['output']>;
  location: Maybe<WarehouseLocation>;
  modifiedBy: Maybe<Employee>;
  price: Maybe<Money>;
  product: Maybe<Product>;
  quantity: Maybe<Scalars['Int']['output']>;
  reservedQuantity: Maybe<Scalars['Int']['output']>;
  shelf: Maybe<WarehouseShelf>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  waybill: Maybe<WarehouseWaybill>;
};

export type WarehouseStockImport = {
  __typename?: 'WarehouseStockImport';
  clearOnImport: Scalars['Boolean']['output'];
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  documentKey: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  importProducts: Maybe<Array<Maybe<WarehouseImportProduct>>>;
  location: Maybe<WarehouseLocation>;
  modifiedBy: Maybe<Employee>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type WarehouseWaybill = {
  __typename?: 'WarehouseWaybill';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  distributedProductsCount: Maybe<Scalars['Int']['output']>;
  documentKey: Maybe<Scalars['String']['output']>;
  employees: Maybe<Array<Maybe<Employee>>>;
  error: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  internalDocumentNr: Maybe<Scalars['String']['output']>;
  invoiceNr: Maybe<Scalars['String']['output']>;
  isAbleSetToReviewed: Maybe<Scalars['Boolean']['output']>;
  isArrived: Maybe<Scalars['Boolean']['output']>;
  isDeletable: Maybe<Scalars['Boolean']['output']>;
  location: Maybe<WarehouseLocation>;
  modifiedBy: Maybe<Employee>;
  originWaybill: Maybe<WarehouseWaybill>;
  products: Maybe<Array<Maybe<WarehouseWaybillProduct>>>;
  productsCount: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['String']['output']>;
  stockProducts: Maybe<Array<Maybe<WarehouseStock>>>;
  stockProductsCount: Maybe<Scalars['Int']['output']>;
  supplier: Maybe<BusinessSupplier>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type WarehouseWaybillProduct = {
  __typename?: 'WarehouseWaybillProduct';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  deliveryNote: Maybe<Scalars['String']['output']>;
  distributedQuantity: Maybe<Scalars['Int']['output']>;
  exchangeMpn: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  importStatus: Maybe<Scalars['String']['output']>;
  isCreatedFromOrder: Maybe<Scalars['Boolean']['output']>;
  isProductExistsInOrder: Maybe<Scalars['Boolean']['output']>;
  modifiedBy: Maybe<Employee>;
  mpn: Maybe<Scalars['String']['output']>;
  mpnFormatted: Maybe<Scalars['String']['output']>;
  order: Maybe<Order>;
  orderSuggestions: Maybe<Array<Maybe<WarehouseWaybillProductOrderSuggestion>>>;
  price: Maybe<Money>;
  product: Maybe<Product>;
  productQuantityInOrder: Maybe<Scalars['Int']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
  reference: Maybe<Scalars['String']['output']>;
  supplierRetailDiscount: Maybe<Scalars['Int']['output']>;
  supplierRetailPrice: Maybe<Money>;
  title: Maybe<Scalars['String']['output']>;
  toStockEvents: Maybe<Array<Maybe<EventProductToStock>>>;
  totalPrice: Maybe<Money>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  waybill: Maybe<WarehouseWaybill>;
  waybillProductOrderProducts: Maybe<Array<Maybe<WarehouseWaybillProductOrderProduct>>>;
};

export type WarehouseWaybillProductOrderProduct = {
  __typename?: 'WarehouseWaybillProductOrderProduct';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Employee>;
  id: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Employee>;
  orderProduct: Maybe<OrderProduct>;
  quantity: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  waybillProduct: Maybe<WarehouseWaybillProduct>;
};

export type WarehouseWaybillProductOrderSuggestion = {
  __typename?: 'WarehouseWaybillProductOrderSuggestion';
  id: Maybe<Scalars['String']['output']>;
  order: Maybe<Order>;
  waybill: Maybe<WarehouseWaybill>;
};

export type Weight = {
  __typename?: 'Weight';
  unit: Scalars['String']['output'];
  value: Scalars['Decimal']['output'];
};

export type CartUpdateProductMutationVariables = Exact<{
  input: B2cCartProductInput;
}>;


export type CartUpdateProductMutation = { __typename?: 'B2cMutation', CartUpdateProduct: { __typename?: 'B2cCartPayload', id: string, totals: Array<{ __typename?: 'CartTotal', id: string, type: string, sequence: number, additionalInfo: string, value: { __typename?: 'Money', amount: any, cents: string, currency: string } }>, cartProducts: Array<{ __typename?: 'B2cCartProduct', id: string, quantity: number, maxOrderQuantity: number, minOrderQuantity: number, factorOrderQuantity: number, priceId: string, price: { __typename?: 'Money', amount: any, cents: string, currency: string }, product: { __typename?: 'B2cProductPayload', id: string, mpn: string, mpnFormatted: string, mpnAnalyzed: string, state: number, keepFlat: boolean, hsCode: string, minimalOrderQuantity: number, ean: string, weight: { __typename?: 'Weight', value: any, unit: string }, dimensions: { __typename?: 'Dimensions', width: any, height: any, depth: any, volume: any, isOverSize: boolean, isOverVolume: boolean, unit: string }, brand: { __typename?: 'B2cBrand', name: string, shortName: string, slug: string }, productInfo: { __typename?: 'B2cProductInfo', id: string, name: string, slug: string, description: string, metaDescription: string }, productParameters: Array<{ __typename?: 'B2cProductParameter', id: string, name: string, type: string, value: string }>, productAssets: Array<{ __typename?: 'B2cProductAsset', id: string, type: string, path: string, extension: string, isMain: boolean, alt: string }>, categories: Array<{ __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number } } } } } }>, prices: Array<{ __typename?: 'B2cProductPrice', id: string, deliveryTermStandardMax: number, deliveryTermStandardMin: number }> } }>, errors: Array<{ __typename?: 'CartProductValidationMessage', productId: string, type: string, title: string, message: string }> } };

export type CategoryFieldsNestedFragment = { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number } } } } } };

export type RecoveryPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type RecoveryPasswordMutation = { __typename?: 'B2cMutation', RecoveryPassword: boolean };

export type RegistrationMutationVariables = Exact<{
  input: RegistrationInput;
}>;


export type RegistrationMutation = { __typename?: 'B2cMutation', Registration: { __typename?: 'B2cRegistrationPayload', email: string, phone: string, country: string, currency: string, locale: string, companyVat: string, billingEmail: string } };

export type SendRecoveryPasswordMailMutationVariables = Exact<{
  input: SendRecoveryPasswordMailInput;
}>;


export type SendRecoveryPasswordMailMutation = { __typename?: 'B2cMutation', SendRecoveryPasswordMail: boolean };

export type UpdateAboutYourselfMutationVariables = Exact<{
  input: B2cAboutYourselfInput;
}>;


export type UpdateAboutYourselfMutation = { __typename?: 'B2cMutation', UpdateAboutYourself: boolean };

export type BrandQueryVariables = Exact<{
  input: BrandQueryInput;
}>;


export type BrandQuery = { __typename?: 'B2cQuery', Brand: { __typename?: 'B2cBrand', id: string, name: string, shortName: string, slug: string, assets: Array<{ __typename?: 'B2cBrandAsset', id: string, path: string, type: string }> } };

export type BrandsByCategoryQueryVariables = Exact<{
  input: BrandsByCategoryInput;
}>;


export type BrandsByCategoryQuery = { __typename?: 'B2cQuery', BrandsByCategory: Array<{ __typename?: 'B2cBrand', id: string }> };

export type CarBrandsListQueryVariables = Exact<{ [key: string]: never; }>;


export type CarBrandsListQuery = { __typename?: 'B2cQuery', CarBrandsList: Array<{ __typename?: 'B2cBrand', id: string, name: string, shortName: string, slug: string, assets: Array<{ __typename?: 'B2cBrandAsset', id: string, type: string, path: string }> }> };

export type CartQueryVariables = Exact<{ [key: string]: never; }>;


export type CartQuery = { __typename?: 'B2cQuery', Cart: { __typename?: 'B2cCartPayload', id: string, totals: Array<{ __typename?: 'CartTotal', id: string, type: string, sequence: number, additionalInfo: string, value: { __typename?: 'Money', amount: any, cents: string, currency: string } }>, cartProducts: Array<{ __typename?: 'B2cCartProduct', id: string, quantity: number, maxOrderQuantity: number, minOrderQuantity: number, factorOrderQuantity: number, priceId: string, price: { __typename?: 'Money', amount: any, cents: string, currency: string }, product: { __typename?: 'B2cProductPayload', id: string, mpn: string, mpnFormatted: string, mpnAnalyzed: string, productInfo: { __typename?: 'B2cProductInfo', id: string, name: string, slug: string, description: string, metaDescription: string }, weight: { __typename?: 'Weight', value: any, unit: string }, brand: { __typename?: 'B2cBrand', id: string, name: string, slug: string, shortName: string }, productParameters: Array<{ __typename?: 'B2cProductParameter', id: string, name: string, type: string, value: string }>, productAssets: Array<{ __typename?: 'B2cProductAsset', id: string, type: string, path: string, extension: string, isMain: boolean, alt: string }>, categories: Array<{ __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number } } } } } }>, prices: Array<{ __typename?: 'B2cProductPrice', id: string, deliveryTermStandardMax: number, deliveryTermStandardMin: number }> } }>, errors: Array<{ __typename?: 'CartProductValidationMessage', productId: string, type: string, title: string, message: string }> } };

export type CategoriesByBrandQueryVariables = Exact<{
  input: CategoriesByBrandInput;
}>;


export type CategoriesByBrandQuery = { __typename?: 'B2cQuery', CategoriesByBrand: Array<{ __typename?: 'B2cCategory', id: string }> };

export type CategoriesTreeQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesTreeQuery = { __typename?: 'B2cQuery', CategoriesTree: Array<{ __typename?: 'B2cCategoryTreePayload', id: string, type: string, name: string, icon: string, image: string, slug: string, children: Array<{ __typename?: 'B2cCategoryTreePayload', id: string, type: string, name: string, icon: string, image: string, slug: string, children: Array<{ __typename?: 'B2cCategoryTreePayload', id: string, type: string, name: string, icon: string, image: string, slug: string, children: Array<{ __typename?: 'B2cCategoryTreePayload', id: string, type: string, name: string, icon: string, image: string, slug: string, children: Array<{ __typename?: 'B2cCategoryTreePayload', id: string, type: string, name: string, icon: string, image: string, slug: string, children: Array<{ __typename?: 'B2cCategoryTreePayload', id: string, type: string, name: string, icon: string, image: string, slug: string }> }> }> }> }> }> };

export type TreeCategoryFieldsFragment = { __typename?: 'B2cCategoryTreePayload', id: string, type: string, name: string, icon: string, image: string, slug: string };

export type TreeCategoryFieldsNestedFragment = { __typename?: 'B2cCategoryTreePayload', id: string, type: string, name: string, icon: string, image: string, slug: string, children: Array<{ __typename?: 'B2cCategoryTreePayload', id: string, type: string, name: string, icon: string, image: string, slug: string, children: Array<{ __typename?: 'B2cCategoryTreePayload', id: string, type: string, name: string, icon: string, image: string, slug: string, children: Array<{ __typename?: 'B2cCategoryTreePayload', id: string, type: string, name: string, icon: string, image: string, slug: string, children: Array<{ __typename?: 'B2cCategoryTreePayload', id: string, type: string, name: string, icon: string, image: string, slug: string, children: Array<{ __typename?: 'B2cCategoryTreePayload', id: string, type: string, name: string, icon: string, image: string, slug: string }> }> }> }> }> };

export type CustomerChannelQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerChannelQuery = { __typename?: 'B2cQuery', CustomerChannel: { __typename?: 'B2cCustomerChannelPayload', vatCoefficient: number, customer: { __typename?: 'B2cCustomer', id: string, locale: string, currency: string, email: string, country: { __typename?: 'Country', id: string, code: string, name: string } }, currentCountry: { __typename?: 'Country', id: string, name: string, code: string }, availableCountries: Array<{ __typename?: 'Country', id: string, name: string, code: string, vatRate: number }>, salesChannel: { __typename?: 'SalesChannelOptions', id: string, defaultLanguage: string, currency: { __typename?: 'Currency', id: string, code: string, base: string, rate: number }, countries: Array<{ __typename?: 'Country', id: string, code: string, currencyCode: string, name: string }> } } };

export type FeaturedBrandsListQueryVariables = Exact<{ [key: string]: never; }>;


export type FeaturedBrandsListQuery = { __typename?: 'B2cQuery', FeaturedBrandsList: Array<{ __typename?: 'FeaturedBrand', id: string, brand: { __typename?: 'BusinessBrand', id: string, name: string, shortName: string, slug: string, assets: Array<{ __typename?: 'BusinessBrandAsset', id: string, type: string, path: string }> } }> };

export type MinimalShippingRateQueryVariables = Exact<{
  input: ShippingRateInput;
}>;


export type MinimalShippingRateQuery = { __typename?: 'B2cQuery', MinimalShippingRate: { __typename?: 'MinimalShippingPayload', country: { __typename?: 'Country', id: string, code: string, name: string }, shippingMethod: { __typename?: 'ShippingMethod', id: string, name: string, price: { __typename?: 'Money', amount: any, cents: string, currency: string } } } };

export type ProductQueryVariables = Exact<{
  input: ProductQueryInput;
}>;


export type ProductQuery = { __typename?: 'B2cQuery', Product: { __typename?: 'B2cProductPayload', id: string, mpn: string, mpnFormatted: string, mpnAnalyzed: string, state: number, keepFlat: boolean, hsCode: string, minimalOrderQuantity: number, ean: string, weight: { __typename?: 'Weight', value: any, unit: string }, dimensions: { __typename?: 'Dimensions', width: any, height: any, depth: any, volume: any, isOverSize: boolean, isOverVolume: boolean, unit: string }, brand: { __typename?: 'B2cBrand', id: string, name: string, shortName: string, slug: string }, productInfo: { __typename?: 'B2cProductInfo', id: string, name: string, slug: string, description: string, metaDescription: string }, productParameters: Array<{ __typename?: 'B2cProductParameter', id: string, name: string, type: string, value: string }>, productAssets: Array<{ __typename?: 'B2cProductAsset', id: string, type: string, path: string, extension: string, isMain: boolean, alt: string }>, categories: Array<{ __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number } } } } } }>, crosses: Array<{ __typename?: 'B2cProductPayload', id: string, productType: string, state: number, brand: { __typename?: 'B2cBrand', name: string, shortName: string, slug: string, defaultProductType: string }, categories: Array<{ __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number } } } } } }>, productInfo: { __typename?: 'B2cProductInfo', slug: string }, prices: Array<{ __typename?: 'B2cProductPrice', id: string, supplierName: string, deliveryTermStandardMin: number, deliveryTermStandardMax: number, deliveryTermExpressMin: number, deliveryTermExpressMax: number, isLocalStockSupplier: boolean, availableStockCount: number, price: { __typename?: 'Money', amount: any, cents: string, currency: string }, brand: { __typename?: 'B2cBrand', id: string, name: string, shortName: string, slug: string } }> }>, prices: Array<{ __typename?: 'B2cProductPrice', id: string, supplierName: string, deliveryTermStandardMin: number, deliveryTermStandardMax: number, deliveryTermExpressMin: number, deliveryTermExpressMax: number, isLocalStockSupplier: boolean, availableStockCount: number, price: { __typename?: 'Money', amount: any, cents: string, currency: string }, brand: { __typename?: 'B2cBrand', id: string, name: string, shortName: string, slug: string } }> } };

export type ProductPricesFragment = { __typename?: 'B2cProductPayload', prices: Array<{ __typename?: 'B2cProductPrice', id: string, supplierName: string, deliveryTermStandardMin: number, deliveryTermStandardMax: number, deliveryTermExpressMin: number, deliveryTermExpressMax: number, isLocalStockSupplier: boolean, availableStockCount: number, price: { __typename?: 'Money', amount: any, cents: string, currency: string }, brand: { __typename?: 'B2cBrand', id: string, name: string, shortName: string, slug: string } }> };

export type CarFieldsFragment = { __typename?: 'B2cCar', id: string, name: string, type: string, slug: string, isEnabled: boolean, lvl: number };

export type CarFieldsNestedFragment = { __typename?: 'B2cCar', id: string, name: string, type: string, slug: string, isEnabled: boolean, lvl: number, parent: { __typename?: 'B2cCar', id: string, name: string, type: string, slug: string, isEnabled: boolean, lvl: number, parent: { __typename?: 'B2cCar', id: string, name: string, type: string, slug: string, isEnabled: boolean, lvl: number, parent: { __typename?: 'B2cCar', id: string, name: string, type: string, slug: string, isEnabled: boolean, lvl: number, parent: { __typename?: 'B2cCar', id: string, name: string, type: string, slug: string, isEnabled: boolean, lvl: number } } } } };

export type CategoryFieldsFragment = { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number };

export type ProductsSearchQueryVariables = Exact<{
  input: B2cProductsSearchInput;
}>;


export type ProductsSearchQuery = { __typename?: 'B2cQuery', ProductsSearch: { __typename?: 'B2cProductsSearchPayload', categories: Array<{ __typename?: 'B2cCategoryTreePayload', id: string, type: string, name: string, shortName: string, slug: string, url: string, icon: string, image: string }>, records: Array<{ __typename?: 'B2cProductSearchPayload', id: string, mpn: string, mpnFormatted: string, mpnAnalyzed: string, state: number, keepFlat: boolean, hsCode: string, minimalOrderQuantity: number, minPrice: number, maxPrice: number, ean: string, brandName: string, weight: { __typename?: 'Weight', value: any, unit: string }, dimensions: { __typename?: 'Dimensions', width: any, height: any, depth: any, volume: any, isOverSize: boolean, isOverVolume: boolean, unit: string }, productInfo: { __typename?: 'B2cProductInfo', id: string, name: string, slug: string, description: string, metaDescription: string }, productAssets: Array<{ __typename?: 'B2cProductAsset', id: string, type: string, path: string, extension: string, isMain: boolean, alt: string }>, categories: Array<{ __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number, parent: { __typename?: 'B2cCategory', id: string, type: string, name: string, shortName: string, slug: string, level: number, lft: number, rgt: number } } } } } }> }>, pagination: { __typename?: 'Pagination', current: number, limit: number, totalCount: number, totalPages: number } } };

export type RootCategoriesPreviewQueryVariables = Exact<{ [key: string]: never; }>;


export type RootCategoriesPreviewQuery = { __typename?: 'B2cQuery', RootCategoriesPreview: Array<{ __typename?: 'Category', id: string, assets: Array<{ __typename?: 'CategoryAsset', path: string, type: string }>, translation: { __typename?: 'CategoryTranslation', nameEn: string, nameRu: string, nameDe: string, nameFr: string, nameEs: string, namePl: string } }> };

export type StaticPageContentQueryVariables = Exact<{
  input: StaticPageContentInput;
}>;


export type StaticPageContentQuery = { __typename?: 'B2cQuery', StaticPageContent: { __typename?: 'StaticPageContentType', id: string, content: string } };

export type TopCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type TopCategoriesQuery = { __typename?: 'B2cQuery', TopCategories: Array<{ __typename?: 'TopCategory', id: string, category: { __typename?: 'Category', id: string, assets: Array<{ __typename?: 'CategoryAsset', path: string, type: string }>, translation: { __typename?: 'CategoryTranslation', nameEn: string, nameRu: string, nameDe: string, nameFr: string, nameEs: string, namePl: string } } }> };

export type UrlDataQueryVariables = Exact<{
  input: UrlDataQueryInput;
}>;


export type UrlDataQuery = { __typename?: 'B2cQuery', UrlData: { __typename?: 'B2cUrlDataPayload', type: string, brand: { __typename?: 'B2cBrand', id: string }, category: { __typename?: 'B2cCategory', id: string }, product: { __typename?: 'B2cProductPayload', id: string } } };

export const CategoryFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"categoryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"lft"}},{"kind":"Field","name":{"kind":"Name","value":"rgt"}}]}}]} as unknown as DocumentNode<CategoryFieldsFragment, unknown>;
export const CategoryFieldsNestedFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"categoryFieldsNested"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"categoryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"lft"}},{"kind":"Field","name":{"kind":"Name","value":"rgt"}}]}}]} as unknown as DocumentNode<CategoryFieldsNestedFragment, unknown>;
export const TreeCategoryFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"treeCategoryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCategoryTreePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]} as unknown as DocumentNode<TreeCategoryFieldsFragment, unknown>;
export const TreeCategoryFieldsNestedFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"treeCategoryFieldsNested"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCategoryTreePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"treeCategoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"treeCategoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"treeCategoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"treeCategoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"treeCategoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"treeCategoryFields"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"treeCategoryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCategoryTreePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]} as unknown as DocumentNode<TreeCategoryFieldsNestedFragment, unknown>;
export const ProductPricesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"productPrices"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cProductPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"cents"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierName"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTermStandardMin"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTermStandardMax"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTermExpressMin"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTermExpressMax"}},{"kind":"Field","name":{"kind":"Name","value":"isLocalStockSupplier"}},{"kind":"Field","name":{"kind":"Name","value":"availableStockCount"}}]}}]}}]} as unknown as DocumentNode<ProductPricesFragment, unknown>;
export const CarFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"carFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCar"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"lvl"}}]}}]} as unknown as DocumentNode<CarFieldsFragment, unknown>;
export const CarFieldsNestedFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"carFieldsNested"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCar"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"carFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"carFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"carFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"carFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"carFields"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"carFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCar"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"lvl"}}]}}]} as unknown as DocumentNode<CarFieldsNestedFragment, unknown>;
export const CartUpdateProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CartUpdateProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCartProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CartUpdateProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"totals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"cents"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"additionalInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cartProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"maxOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"minOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"factorOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"priceId"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"cents"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mpn"}},{"kind":"Field","name":{"kind":"Name","value":"mpnFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"mpnAnalyzed"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"keepFlat"}},{"kind":"Field","name":{"kind":"Name","value":"hsCode"}},{"kind":"Field","name":{"kind":"Name","value":"minimalOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"weight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dimensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"isOverSize"}},{"kind":"Field","name":{"kind":"Name","value":"isOverVolume"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"metaDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productParameters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"isMain"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFieldsNested"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTermStandardMax"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTermStandardMin"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"categoryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"lft"}},{"kind":"Field","name":{"kind":"Name","value":"rgt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"categoryFieldsNested"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CartUpdateProductMutation, CartUpdateProductMutationVariables>;
export const RecoveryPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecoveryPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResetPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RecoveryPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<RecoveryPasswordMutation, RecoveryPasswordMutationVariables>;
export const RegistrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Registration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Registration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"companyVat"}},{"kind":"Field","name":{"kind":"Name","value":"billingEmail"}}]}}]}}]} as unknown as DocumentNode<RegistrationMutation, RegistrationMutationVariables>;
export const SendRecoveryPasswordMailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendRecoveryPasswordMail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendRecoveryPasswordMailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SendRecoveryPasswordMail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SendRecoveryPasswordMailMutation, SendRecoveryPasswordMailMutationVariables>;
export const UpdateAboutYourselfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAboutYourself"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"B2cAboutYourselfInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UpdateAboutYourself"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateAboutYourselfMutation, UpdateAboutYourselfMutationVariables>;
export const BrandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Brand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BrandQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Brand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<BrandQuery, BrandQueryVariables>;
export const BrandsByCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandsByCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BrandsByCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"BrandsByCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BrandsByCategoryQuery, BrandsByCategoryQueryVariables>;
export const CarBrandsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CarBrandsList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CarBrandsList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]} as unknown as DocumentNode<CarBrandsListQuery, CarBrandsListQueryVariables>;
export const CartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"totals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"cents"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"additionalInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cartProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"maxOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"minOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"factorOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"priceId"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"cents"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"metaDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mpn"}},{"kind":"Field","name":{"kind":"Name","value":"mpnFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"mpnAnalyzed"}},{"kind":"Field","name":{"kind":"Name","value":"weight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productParameters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"isMain"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFieldsNested"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTermStandardMax"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTermStandardMin"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"categoryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"lft"}},{"kind":"Field","name":{"kind":"Name","value":"rgt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"categoryFieldsNested"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CartQuery, CartQueryVariables>;
export const CategoriesByBrandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CategoriesByBrand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoriesByBrandInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CategoriesByBrand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CategoriesByBrandQuery, CategoriesByBrandQueryVariables>;
export const CategoriesTreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CategoriesTree"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CategoriesTree"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"treeCategoryFieldsNested"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"treeCategoryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCategoryTreePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"treeCategoryFieldsNested"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCategoryTreePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"treeCategoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"treeCategoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"treeCategoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"treeCategoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"treeCategoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"treeCategoryFields"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CategoriesTreeQuery, CategoriesTreeQueryVariables>;
export const CustomerChannelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomerChannel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CustomerChannel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salesChannel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"base"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatCoefficient"}}]}}]}}]} as unknown as DocumentNode<CustomerChannelQuery, CustomerChannelQueryVariables>;
export const FeaturedBrandsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FeaturedBrandsList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FeaturedBrandsList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FeaturedBrandsListQuery, FeaturedBrandsListQueryVariables>;
export const MinimalShippingRateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MinimalShippingRate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingRateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"MinimalShippingRate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"cents"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MinimalShippingRateQuery, MinimalShippingRateQueryVariables>;
export const ProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Product"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mpn"}},{"kind":"Field","name":{"kind":"Name","value":"mpnFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"mpnAnalyzed"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"keepFlat"}},{"kind":"Field","name":{"kind":"Name","value":"hsCode"}},{"kind":"Field","name":{"kind":"Name","value":"minimalOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"weight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dimensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"isOverSize"}},{"kind":"Field","name":{"kind":"Name","value":"isOverVolume"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"metaDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productParameters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"isMain"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"productPrices"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFieldsNested"}}]}},{"kind":"Field","name":{"kind":"Name","value":"crosses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"defaultProductType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFieldsNested"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"productPrices"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"categoryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"lft"}},{"kind":"Field","name":{"kind":"Name","value":"rgt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"productPrices"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cProductPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"cents"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierName"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTermStandardMin"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTermStandardMax"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTermExpressMin"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTermExpressMax"}},{"kind":"Field","name":{"kind":"Name","value":"isLocalStockSupplier"}},{"kind":"Field","name":{"kind":"Name","value":"availableStockCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"categoryFieldsNested"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductQuery, ProductQueryVariables>;
export const ProductsSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductsSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"B2cProductsSearchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ProductsSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mpn"}},{"kind":"Field","name":{"kind":"Name","value":"mpnFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"mpnAnalyzed"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"keepFlat"}},{"kind":"Field","name":{"kind":"Name","value":"hsCode"}},{"kind":"Field","name":{"kind":"Name","value":"minimalOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"minPrice"}},{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"weight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dimensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"isOverSize"}},{"kind":"Field","name":{"kind":"Name","value":"isOverVolume"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"metaDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"isMain"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFieldsNested"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brandName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"categoryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"lft"}},{"kind":"Field","name":{"kind":"Name","value":"rgt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"categoryFieldsNested"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"B2cCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"categoryFields"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductsSearchQuery, ProductsSearchQueryVariables>;
export const RootCategoriesPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RootCategoriesPreview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RootCategoriesPreview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"nameRu"}},{"kind":"Field","name":{"kind":"Name","value":"nameDe"}},{"kind":"Field","name":{"kind":"Name","value":"nameFr"}},{"kind":"Field","name":{"kind":"Name","value":"nameEs"}},{"kind":"Field","name":{"kind":"Name","value":"namePl"}}]}}]}}]}}]} as unknown as DocumentNode<RootCategoriesPreviewQuery, RootCategoriesPreviewQueryVariables>;
export const StaticPageContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StaticPageContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StaticPageContentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"StaticPageContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode<StaticPageContentQuery, StaticPageContentQueryVariables>;
export const TopCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TopCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TopCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"nameRu"}},{"kind":"Field","name":{"kind":"Name","value":"nameDe"}},{"kind":"Field","name":{"kind":"Name","value":"nameFr"}},{"kind":"Field","name":{"kind":"Name","value":"nameEs"}},{"kind":"Field","name":{"kind":"Name","value":"namePl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TopCategoriesQuery, TopCategoriesQueryVariables>;
export const UrlDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UrlData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UrlDataQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UrlData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UrlDataQuery, UrlDataQueryVariables>;